<template>
  <div @click="closeModalsDefault">
    <div
      v-show="getDisplayHelpText"
      class="help-text" >
      <div
        class="closer"
        @click.stop="closeHelpText"/>
      <div class="help-text-container">
        <div class="help-text-header d-flex justify-content-between align-items-center">
          <h4> Did you know the editor now supports video?</h4>
          <div @click.stop="closeHelpText">
            <icon
              class="cursor-pointer"
              name="close-icon"/>
          </div>
        </div>
        <div class="help-text-body">
          <p>To enable it, turn on "Video Mode" in the Details toolbar or click "Enable" below.</p>
          <div class="w-100 d-flex justify-content-between align-items-center">
            <label>
              <input
                v-model="videoHelpChecked"
                type="checkbox"
                class="form-check-input" >
              Don't show this message again.
            </label>

            <button
              class="btn-primary bm-primary-btn"
              @click.stop="enableVideoMode">Enable</button>
          </div>
        </div>
      </div>
    </div>
    <div class="main-panel-wrapper bg-white">
      <div
        v-if="!getDisplayAnimationPanel"
        class="main-widget-wrapper scroller h-100">
        <div
          class="widget-inner p-0 bg-white expand-icon"
          @click.stop="toggleDetailSection">
          <collapsible-panel :is-open="isOpenDetailSection">
            <div
              class="bm-collapse Details color-selector shape-selector p-0 mt-12 mb-0"
              @click.stop="stopPropagation">
              <div class="details-text-field pb-20 border-1 border border-light-gray rounded-4 border-end-0 border-start-0 border-top-0 border-light-gray px-16">
                <text-field
                  v-model="productName"
                  :number="false"
                  label="Product title"
                />
              </div>
              <Product-Page-Size v-if="isOpenDetailSection"/>
              <div class="px-16 pt-20 pb-20 d-flex align-items-end dimensions-select">

                <text-field
                  v-model="getSelectedPageWidth"
                  :second-value="getSelectedPageHeight"
                  :number="isNumberField"
                  :is-inch="isInch"
                  :is-product-size-ratio="isProductSizeRatio"
                  label="Width"
                  class="p-0"/>
                <div
                  class="adjust-icon align-self-end expand-icon mb-9 hover-icon"
                  @click="toggleProductSizeRatioFlag">
                  <icon :name="isProductSizeRatio ? 'constraints-proportion-icon' : 'constraints-proportion-iconOFF'"/>
                </div>
                <text-field
                  v-model="getSelectedPageHeight"
                  :second-value="getSelectedPageWidth"
                  :number="isNumberField"
                  :is-inch="isInch"
                  :is-product-size-ratio="isProductSizeRatio"
                  label="Height"
                  class="p-0 me-8"/>
                <div
                  ref = "detailsDropdown"
                  :class="[isDropdownShown ? 'show-content' : '']"
                  class=" dropdown-panel  d-flex justify-content-between align-items-center py-6 ps-16 pe-10 mt-3 position-relative border border-1 border-light-gray rounded rounded-4 unit-select"
                  @click="showSelectionDropDown($event)">
                  <span
                    class="selected-font me-10">{{ productSize.selectedUnit }}</span>
                  <span class="custom-icon">
                    <icon name="chevron"/>
                  </span>
                  <ul class="dropdown-selection list-unstyled border border-1 border-blue-primary border-top-0 mb-0 position-absolute w-100 bg-white d-none">
                    <li
                      class="selection py-6 px-16"
                      @click="selected($event)">{{ productSize.otherUnit }}
                    </li>
                  </ul>
                </div>
                <div
                  class="adjust-icon align-self-end expand-icon mb-9 ps-15"
                  @click="showFavouriteSizeInModel">
                  <icon :name="'star-un-favourite'"/>
                </div>

              </div>
              <utility-buttons-panel
                id="1"
                :is-toggled="isGrayScaleOn"
                label="Grayscale PDF:"/>
              <utility-buttons-panel
                id="2"
                :is-toggled="isSnappingEnabled"
                label="Alignment Guides:"/>
              <utility-buttons-panel
                v-if="1"
                id="3"
                :is-toggled="isRulerOn"
                label="Show Rulers:"
              />
              <utility-buttons-panel
                id="3"
                :is-toggled="isVideoMoodOn"
                :is-same-dimension-pages="checkProductPagesAreInSameDimension"
                label="Video Mode:"
              />
              <utility-buttons-panel
                v-if="isProductCrop.isShowCrop"
                id="3"
                :is-toggled="!isProductCrop.allowCrop"
                label="Crop Marks"/>
            </div>
          </collapsible-panel>
        </div>
        <div
          v-if="isHealthCareMarketingCenter"
          class="widget-inner py-12 px-16">
          <panel-heading
            :product-width="width"
            :product-height="height"
            :section="bankType == `CreditUnion`? LeftSectionPanelTypes.NCUA : LeftSectionPanelTypes.FDIC"
            :title="bankType == `CreditUnion`? `NCUA`:`FDIC`"
            left-icon="fdic"
          />
          <div
            v-if="getOpenPanel== LeftSectionPanelTypes.FDIC"
            class="bm-collapse Images color-selector shape-selector mt-32 mb-8">
            <div class="color-select-buttons-wrapper d-flex justify-content-between">
              <color-select-button
                id="1"
                :selected-button="activeObjectForLeftPanel && activeObjectForLeftPanel.ImageType == 'FDICText'"
                :type="bankType == `CreditUnion`? `NCUA`:`FDIC`"
                title="Black"
                @toggleActive="activeButton"
              />
              <color-select-button
                id="2"
                :selected-button="activeObjectForLeftPanel &&activeObjectForLeftPanel.ImageType == 'FDICTextWhite'"
                :type="bankType == `CreditUnion`? `NCUA`:`FDIC`"
                title="White"
                @toggleActive="activeButton"
              />
            </div>
          </div>
        </div>
        <div
          v-if="isHealthCareMarketingCenter"
          class="widget-inner py-12 px-16">
          <panel-heading
            :product-width="width"
            :product-height="height"
            :section="LeftSectionPanelTypes.HOUSING"
            title="Equal Housing"
            left-icon="equal-housing"
          />
          <div
            v-show="getOpenPanel == LeftSectionPanelTypes.HOUSING"
            class="accordion-collapse">
            <div class="accordion-body p-0">
              <div class="bm-collapse Images color-selector shape-selector mt-32 mb-8">
                <div class="color-select-buttons-wrapper d-flex justify-content-between">
                  <color-select-button
                    id="3"
                    :selected-button="activeObjectForLeftPanel && activeObjectForLeftPanel.ImageType == 'FDICLogo'"
                    title="Black"
                    type="HOUSING"
                    @toggleActive="activeButton"/>
                  <color-select-button
                    id="4"
                    :selected-button="activeObjectForLeftPanel && activeObjectForLeftPanel.ImageType == 'FDICLogoWhite'"
                    title="White"
                    type="HOUSING"
                    @toggleActive="activeButton"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="widget-inner py-12 px-16">
          <panel-heading
            :product-width="width"
            :product-height="height"
            :section="LeftSectionPanelTypes.TEXT"
            title="Text"
            left-icon="text"/>
          <div
            v-if="getOpenPanel == LeftSectionPanelTypes.TEXT"
            class="accordion-collapse"
            style="position: relative">
            <color-picker
              v-if="this.$store.getters.getIsOpen"
              :color="getColorLabel"
              class="position max-z-index"
              display-style="float"
            />
            <div class="accordion-body p-0">
              <div class="bm-collapse Text color-selector shape-selector mt-32 mb-8">
                <font-family-select
                  :value="getFontFamily"
                  label="Font family"/>
                <div class="font-family-selection  d-flex adjustments-btns mt-20">
                  <size-adjust-button
                    :key="getFontSize"
                    :value="getFontSize"
                    :scale="activeObjectForLeftPanel.scaleX"
                    label="Size"
                    class="me-12"/>
                  <size-adjust-button
                    :key="getLineSpacing"
                    :value="getLineSpacing"
                    label="Line Spacing"/>
                </div>
                <div class="font-family-selection  size-spacing-controller d-flex justify-content-between mt-20">
                  <color-selector
                    :key="getColorLabel"
                    :colorobject="getColorLabel"

                    label="Color"/>
                  <div class="size-controller-wrapper spacing col-md-6 outline other">
                    <label class="mb-4">Style</label>
                    <ul class="list-unstyled d-flex ">
                      <li class="me-12 position-relative">
                        <div
                          id="1"
                          class="checkbox-button-wrapper position-relative" >
                          <input
                            id="bold-icon"
                            :disabled="isEditorEnable"
                            :checked="getFontStyleBold"
                            type="checkbox"
                            class="checkmark position-absolute"
                            value="bold-icon"
                            @change="triggerUpdateTextProperties({ command: TinyMCECommandTypes.Bold, value: !getFontStyleBold, commandType: TextCommandTypes.TinyMceCommand})">
                          <label
                            v-tooltip="'Toggle Bold Text'"
                            for="bold-icon"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="boldicon" />
                          </label>

                        </div>

                      </li>
                      <li class="me-12 position-relative">
                        <div
                          v-tooltip="'Italic'"
                          class="checkbox-button-wrapper position-relative"
                        >
                          <input
                            id="italic"
                            :disabled="isEditorEnable"
                            :checked="getFontStyleItalic"
                            type="checkbox"
                            class="checkmark position-absolute"
                            value="bold-icon"
                            @change="triggerUpdateTextProperties({ command: TinyMCECommandTypes.Italic, value: !getFontStyleItalic, commandType:TextCommandTypes.TinyMceCommand})">
                          <label
                            for="italic"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="Italic"/>
                          </label>
                        </div>
                      </li>
                      <li class="position-relative">
                        <div
                          id="3"
                          class="checkbox-button-wrapper position-relative">
                          <input
                            id="underline"
                            :disabled="isEditorEnable"
                            :checked="getFontStyleUnderline"
                            type="checkbox"
                            class="checkmark position-absolute"
                            value="bold-icon"
                            @change="triggerUpdateTextProperties({ command: TinyMCECommandTypes.Underline, value: !getFontStyleUnderline, commandType:TextCommandTypes.TinyMceCommand})">
                          <label
                            v-tooltip="'Underline'"
                            for="underline"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="underlineicon"/>
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>

                </div>
                <div class="outer-box-images canvas-position-controls mt-20">
                  <div class="mb-8">
                    <span class="text-box-images">Position</span>
                  </div>
                  <div class="d-flex ">
                    <div class="button-box-images me-12">
                      <div
                        class=" position-relative checkbox-button-wrapper radio-button-wrapper">
                        <input
                          id="image-align-left"
                          :checked="getObjectCanvasAlignment.horizontalAlignment == 'left'"
                          type="radio"
                          name="alignment-horizontal"
                          class="checkmark position-absolute"
                          value="align-middle"
                          @change="alignObjectPosition('left',productCrop)">
                        <label
                          v-tooltip="'Left'"
                          for="image-align-left"
                          class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                          <icon name="alignleft"/>
                        </label>
                      </div>
                    </div>
                    <div class="button-box-images me-12">
                      <div
                        class="position-relative checkbox-button-wrapper radio-button-wrapper">
                        <input
                          id="align-middle"
                          :checked="getObjectCanvasAlignment.horizontalAlignment == 'center'"
                          type="radio"
                          name="alignment-horizontal"
                          class="checkmark position-absolute"
                          value="align-middle"
                          @change="alignObjectPosition('center',productCrop)">
                        <label
                          v-tooltip="'Center'"
                          for="align-middle"
                          class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                          <icon name="aligncenter"/>
                        </label>
                      </div>
                    </div>
                    <div class="button-box-images me-12">
                      <div
                        class=" checkbox-button-wrapper radio-button-wrapper position-relative">
                        <input
                          id="image-align-right"
                          :checked="getObjectCanvasAlignment.horizontalAlignment == 'right'"
                          type="radio"
                          name="alignment-horizontal"
                          class="checkmark position-absolute"
                          value="align-middle"
                          @change="alignObjectPosition('right',productCrop)">
                        <label
                          v-tooltip="'Right'"
                          for="image-align-right"
                          class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                          <icon name="alignright"/>
                        </label>
                      </div>
                    </div>
                    <div class="button-box-images me-12">
                      <div
                        class="checkbox-button-wrapper radio-button-wrapper position-relative"
                      >
                        <input
                          id="align-top"
                          :checked="getObjectCanvasAlignment.verticalAlignment == 'top'"
                          type="radio"
                          name="alignment-vertical"
                          class="checkmark position-absolute"
                          value="align-middle"
                          @change="alignObjectPosition('top',productCrop)">
                        <label
                          v-tooltip="'Top'"
                          for="align-top"
                          class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                          <icon name="aligntop"/>
                        </label>

                      </div>
                    </div>
                    <div class="button-box-images me-12">
                      <div
                        class=" checkbox-button-wrapper radio-button-wrapper position-relative"
                      >
                        <input
                          id="vertical-align-middle"
                          :checked="getObjectCanvasAlignment.verticalAlignment == 'center'"
                          type="radio"
                          name="alignment-vertical"
                          class="checkmark position-absolute"
                          value="align-middle"
                          @change="alignObjectPosition('middle',productCrop)">
                        <label
                          v-tooltip="'Middle'"
                          for="vertical-align-middle"
                          class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                          <icon name="alignmiddle"/>
                        </label>
                      </div>
                    </div>
                    <div class="button-box-images me-12">
                      <div
                        class=" checkbox-button-wrapper radio-button-wrapper position-relative"
                      >
                        <input
                          id="vertical-align-bottom"
                          :checked="getObjectCanvasAlignment.verticalAlignment === 'bottom'"
                          type="radio"
                          name="alignment-vertical"
                          class="checkmark position-absolute"
                          value="align-middle"
                          @change="alignObjectPosition('bottom',productCrop)">
                        <label
                          v-tooltip="'Align Bottom'"
                          for="vertical-align-bottom"
                          class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                          <icon name="alignbottom"/>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="font-family-selection size-spacing-controller d-flex justify-content-between align-others mt-20">
                  <div class="size-controller-wrapper half-width me-12">
                    <label class="mb-4">Align</label>
                    <ul class="list-unstyled d-flex flex-wrap mb-0">
                      <li class="mb-12 me-12 position-relative">
                        <div
                          class="checkbox-button-wrapper radio-button-wrapper position-relative">
                          <input
                            id="top"
                            :checked="activeObjectForLeftPanel.verticalAlign.toLowerCase() == 'top'"
                            type="radio"
                            name="alignVertical"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="triggerUpdateTextProperties({command:TinyMCECommandTypes.VerticalAlign, value:'top', commandType:TextCommandTypes.VerticalAlignmentCommand})">
                          <label
                            v-tooltip="'Top'"
                            for="top"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="textaligntop"/>
                          </label>
                        </div>
                      </li>
                      <li class="mb-12 me-12 position-relative">
                        <div
                          class="checkbox-button-wrapper radio-button-wrapper position-relative">
                          <input
                            id="middle"
                            :checked="activeObjectForLeftPanel.verticalAlign.toLowerCase() == 'middle'"
                            type="radio"
                            name="alignVertical"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="triggerUpdateTextProperties({command:TinyMCECommandTypes.VerticalAlign, value:'middle', commandType:TextCommandTypes.VerticalAlignmentCommand})">
                          <label
                            v-tooltip="'Middle'"
                            for="middle"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="textaligncenter"/>
                          </label>
                        </div>
                      </li>
                      <li class="mb-12 me-12 position-relative">
                        <div
                          class="checkbox-button-wrapper radio-button-wrapper position-relative">
                          <input
                            id="align-bottom"
                            :checked="activeObjectForLeftPanel.verticalAlign.toLowerCase() == 'bottom'"
                            type="radio"
                            name="alignVertical"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="triggerUpdateTextProperties({command:TinyMCECommandTypes.VerticalAlign, value:'bottom', commandType:TextCommandTypes.VerticalAlignmentCommand})">
                          <label
                            v-tooltip="'Bottom'"
                            for="align-bottom"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="text-align-bottom"/>
                          </label>
                        </div>
                      </li>
                      <li class="mb-12 me-12 position-relative">
                        <div
                          id="7"
                          class="checkbox-button-wrapper radio-button-wrapper position-relative"
                        >
                          <input
                            id="text-left"
                            :checked="activeObjectForLeftPanel.valuesForLeftPanel.isJustifyLeft"
                            type="radio"
                            name="align-horizontal"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="triggerUpdateTextProperties({command:TinyMCECommandTypes.JustifyLeft, value:!activeObjectForLeftPanel.valuesForLeftPanel.isJustifyLeft, commandType:TextCommandTypes.TinyMceCommand})">
                          <label
                            v-tooltip="'Left'"
                            for="text-left"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="text-horizontal-align-left"/>
                          </label>
                        </div>
                      </li>
                      <li class="mb-12 me-12 position-relative">
                        <div
                          id="8"
                          class="checkbox-button-wrapper radio-button-wrapper position-relative"
                        >
                          <input
                            id="text-center"
                            :checked="activeObjectForLeftPanel.valuesForLeftPanel.isJustifyCenter"
                            type="radio"
                            name="align-horizontal"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="triggerUpdateTextProperties({command:TinyMCECommandTypes.JustifyCenter, value:!activeObjectForLeftPanel.valuesForLeftPanel.isJustifyCenter, commandType:TextCommandTypes.TinyMceCommand})">
                          <label
                            v-tooltip="'Center'"
                            for="text-center"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="text-horizontal-align-center"/>
                          </label>
                        </div>

                      </li>
                      <li class="position-relative">
                        <div
                          id="9"
                          class="checkbox-button-wrapper radio-button-wrapper position-relative"
                        >
                          <input
                            id="text-right"
                            :checked="activeObjectForLeftPanel.valuesForLeftPanel.isJustifyRight"
                            type="radio"
                            name="align-horizontal"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="triggerUpdateTextProperties({command:TinyMCECommandTypes.JustifyRight, value:!activeObjectForLeftPanel.valuesForLeftPanel.isJustifyRight, commandType:TextCommandTypes.TinyMceCommand})">
                          <label
                            v-tooltip="'Right'"
                            for="text-right"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="text-horizontal-align-right"/>
                          </label>

                        </div>
                      </li>
                      <li
                        class="position-relative">
                        <div
                          id="10"
                          class="checkbox-button-wrapper radio-button-wrapper position-relative"
                        >
                          <input
                            id="text-justify"
                            :checked="activeObjectForLeftPanel.valuesForLeftPanel.isJustify"
                            type="radio"
                            name="align-horizontal"
                            class="checkmark position-absolute"
                            @change="triggerUpdateTextProperties({command:TinyMCECommandTypes.JustifyFull, value:!activeObjectForLeftPanel.valuesForLeftPanel.isJustify, commandType:TextCommandTypes.TinyMceCommand})">
                          <label
                            v-tooltip="'Justify'"
                            for="text-justify"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="justify-text"/>
                          </label>

                        </div>
                      </li>
                    </ul>
                  </div>

                  <div class="size-controller-wrapper spacing others">
                    <label class="mb-4">Other</label>
                    <ul class="list-unstyled d-flex mb-12">
                      <li class="me-12 position-relative">
                        <div
                          id="11"
                          class="checkbox-button-wrapper radio-button-wrapper position-relative">
                          <input
                            id="bullet-list"
                            :disabled="isEditorEnable"
                            :checked="getBulletList"
                            type="checkbox"
                            name="align"
                            class="checkmark position-absolute"
                            value="bullet-list"
                            @change="triggerUpdateTextProperties({command:TinyMCECommandTypes.InsertUnorderedList, value:!getBulletList, commandType:TextCommandTypes.TinyMceCommand})">
                          <label
                            v-tooltip="'Bullet'"
                            for="bullet-list"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="list-bullets"/>
                          </label>
                        </div>
                      </li>
                      <li class="me-12 position-relative">
                        <div
                          class="checkbox-button-wrapper radio-button-wrapper position-relative"
                        >
                          <input
                            id="number-list"
                            :disabled="isEditorEnable"
                            :checked="getNumberList"
                            :value="getNumberList"
                            type="checkbox"
                            name="align"
                            class="checkmark position-absolute"
                            @change="triggerUpdateTextProperties({command:TinyMCECommandTypes.InsertOrderedList, value:!getNumberList, commandType:TextCommandTypes.TinyMceCommand})">
                          <label
                            v-tooltip="'List'"
                            for="number-list"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="list-numbers"/>
                          </label>
                        </div>
                      </li>
                    </ul>
                    <ul class="list-unstyled d-flex alignment-btns mb-0">
                      <li class="me-12 position-relative">
                        <div
                          id="13"
                          class="checkbox-button-wrapper radio-button-wrapper"
                        >
                          <input
                            id="superscript"
                            :checked="getSupperScript"
                            :disabled="isEditorEnable"
                            type="checkbox"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="triggerUpdateTextProperties({command:TinyMCECommandTypes.Superscript, value:!getSupperScript, commandType:TextCommandTypes.TinyMceCommand})">

                          <label
                            v-tooltip="'Superscript'"
                            for="superscript"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="superscript"/>
                          </label>
                        </div>

                      </li>
                      <li class="me-12 position-relative">
                        <div
                          id="14"
                          class="checkbox-button-wrapper radio-button-wrapper"

                        >
                          <input
                            id="subscript"
                            :checked="getSubScript"
                            :disabled="isEditorEnable"
                            type="checkbox"
                            name="align"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="triggerUpdateTextProperties({command:TinyMCECommandTypes.Subscript, value:!getSubScript, commandType:TextCommandTypes.TinyMceCommand})">
                          <label
                            v-tooltip="'Subscript'"
                            for="subscript"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="subscript"/>
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="outer-box-images canvas-position-controls mt-20">
                  <div class="mb-8">
                    <span class="text-box-images">Effects</span>
                  </div>
                  <div class="animation-panel">
                    <div class="d-flex justify-content-start align-items-center w-100 gap-15">
                      <div class="d-flex justify-content-center flex-column align-items-center"
                           @click="removeTextEffect">
                        <div class="effects-btn d-flex"
                             :class="activeObjectForLeftPanel.textShadow.textEffect === 'none' && activeObjectForLeftPanel.outLine.textEffect === 'none' ? 'active-effect' : ''">
                          <img src="../../assets/images/none.png"/>
                        </div>
                        <div class="fs-12">None</div>
                      </div>
                      <div class="d-flex justify-content-center flex-column align-items-center"
                           @click="applyShadowOnText">
                        <div class="effects-btn d-flex"
                             :class="activeObjectForLeftPanel.textShadow.textEffect === 'shadow' ? 'active-effect' : ''">
                          <img src="../../assets/images/shadow.png"/>
                        </div>
                        <div class="fs-12">Shadow</div>
                      </div>
                      <div class="d-flex justify-content-center flex-column align-items-center"
                           @click="applyOutlineOnText">
                        <div class="effects-btn d-flex"
                             :class="activeObjectForLeftPanel.outLine.textEffect === 'outline' ? 'active-effect' : ''">
                          <img src="../../assets/images/outline.png"/>
                        </div>
                        <div class="fs-12">Outline</div>
                      </div>
                    </div>
                    <div v-if="activeObjectForLeftPanel.textShadow.textEffect === 'shadow'"
                         class="effects-style-container">
                      <div class="effects-subpanel">
                        <!-- Direction (Angle) -->
                        <div class="fs-12 box-name">Direction</div>
                        <div class="effect-container">
                          <input
                              id="direction-range"
                              min="-180"
                              max="180"
                              step="1"
                              :style="{background: `linear-gradient(90deg, #3BB0FA ${(activeObjectForLeftPanel.textShadow.angle + 180) / 3.6}%, #d6d6d6 0%)`}"
                              :value="activeObjectForLeftPanel.textShadow.angle"
                              @input="updateTextShadowProperty('angle', parseInt($event.target.value, 10))"
                              type="range"
                              class="slider rounded rounded-12 btn-outline-0"
                          />
                          <div class="box d-flex justify-content-center align-items-center">
                            <span class="box-value">{{ activeObjectForLeftPanel.textShadow.angle }}°</span>
                          </div>
                        </div>
                      </div>

                      <div class="effects-subpanel">
                        <!-- Distance -->
                        <div class="fs-12 box-name">Distance</div>
                        <div class="effect-container">
                          <input
                              id="distance-range"
                              min="0"
                              step="0.01"
                              max="2"
                              :style="{background: `linear-gradient(90deg, #3BB0FA ${Math.round(activeObjectForLeftPanel.textShadow.distance * 50)}%, #d6d6d6 0%)`}"
                              :value="activeObjectForLeftPanel.textShadow.distance"
                              @input="updateTextShadowProperty('distance', parseFloat($event.target.value))"
                              type="range"
                              class="slider rounded rounded-12 btn-outline-0"
                          />
                          <div class="box d-flex justify-content-center align-items-center">
                            <span class="box-value">{{ Math.round(activeObjectForLeftPanel.textShadow.distance * 50) }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="effects-subpanel">
                        <!-- Blur -->
                        <div class="fs-12 box-name">Blur</div>
                        <div class="effect-container">
                          <input
                              id="blur-range"
                              min="0"
                              max="2"
                              step="0.01"
                              :style="{background:`linear-gradient(90deg, #3BB0FA ${activeObjectForLeftPanel.textShadow.shadowBlur * 50}%, #d6d6d6 0%)`}"
                              :value="activeObjectForLeftPanel.textShadow.shadowBlur"
                              @input="updateTextShadowProperty('shadowBlur', $event.target.value)"
                              type="range"
                              class="slider rounded rounded-12 btn-outline-0"
                          >
                          <div class="box d-flex justify-content-center align-items-center">
                            <span class="box-value">{{ Math.round(activeObjectForLeftPanel.textShadow.shadowBlur * 50) }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex justify-content-between align-items-center mt-10">
                        <!-- Color -->
                        <div class="fs-12 box-name">
                          <span>Color</span>
                        </div>
                        <div class="box d-flex justify-content-center align-items-center" :style="{background: activeObjectForLeftPanel.textShadow.shadowColor}" @click.stop="openColorPicker">
                          <color-picker
                              v-if="isColorPickerOpen"
                              :activeObject="activeObjectForLeftPanel"
                              :color="activeObjectForLeftPanel.textShadow.shadowColor"
                              :isForShadowColor="true"
                              class="position2 max-z-index"
                              display-style="float"
                          />
                        </div>
                      </div>


                    </div>
                    <div v-if="activeObjectForLeftPanel.outLine.textEffect === 'outline'"
                         class="effects-style-container">
                      <div class="effects-subpanel">
                        <div class="fs-12 box-name">
                          <span>Thickness</span>
                        </div>
                        <div class="effect-container">
                          <input
                              id="horizontal-distance-range-"
                              min="0.2"
                              step="0.2"
                              max="2.0"
                              :style="{background:`linear-gradient(90deg, #3BB0FA ${getLinearGradientNumber}%, #d6d6d6 0%)`}"
                              :value="activeObjectForLeftPanel.outLine.strokeWidth"
                              @input="updateTextOutlineProperty('strokeWidth', $event.target.value)"
                              type="range"
                              class="slider rounded rounded-12 btn-outline-0"
                          >
                          <div class="box d-flex justify-content-center align-items-center">
                            <span class="box-value">{{ activeObjectForLeftPanel.outLine.strokeWidth }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between align-items-center mt-10">
                        <div class="fs-12 box-name">
                          <span>Color</span>
                        </div>
                        <div class="box d-flex justify-content-center align-items-center" :style="{background: activeObjectForLeftPanel.outLine.strokeColor}" @click.stop="openColorPicker">
                          <color-picker
                              v-if="isColorPickerOpen"
                              :activeObject="activeObjectForLeftPanel"
                              :color="activeObjectForLeftPanel.outLine.strokeColor"
                              :isForShadowColor="true"
                              class="position2 max-z-index"
                              display-style="float"
                          />
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="widget-inner py-12 px-16">
          <panel-heading
            :section="LeftSectionPanelTypes.Image"
            title="Images"
            left-icon="image"/>
          <div
            v-if="getOpenPanel == LeftSectionPanelTypes.Image"
            class="accordion-collapse">
            <div class="accordion-body p-0">
              <div class="bm-collapse Images color-selector shape-selector">
                <div class="main-box mt-32 mb-8">
                  <div class="outer-box-images">
                    <div class="mb-8">
                      <span class="text-box-images">Position</span>
                    </div>
                    <div class="d-flex ">
                      <div class="button-box-images me-12">
                        <div
                          class=" position-relative checkbox-button-wrapper radio-button-wrapper">
                          <input
                            id="image-align-left"
                            :checked="getObjectCanvasAlignment.horizontalAlignment == 'left'"
                            type="radio"
                            name="alignment-horizontal"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('left',productCrop)">
                          <label
                            v-tooltip="'Left'"
                            for="image-align-left"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="alignleft"/>
                          </label>
                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          class="position-relative checkbox-button-wrapper radio-button-wrapper">
                          <input
                            id="align-middle"
                            :checked="getObjectCanvasAlignment.horizontalAlignment == 'center'"
                            type="radio"
                            name="alignment-horizontal"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('center',productCrop)">
                          <label
                            v-tooltip="'Center'"
                            for="align-middle"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="aligncenter"/>
                          </label>
                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          class=" checkbox-button-wrapper radio-button-wrapper position-relative">
                          <input
                            id="image-align-right"
                            :checked="getObjectCanvasAlignment.horizontalAlignment == 'right'"
                            type="radio"
                            name="alignment-horizontal"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('right',productCrop)">
                          <label
                            v-tooltip="'Right'"
                            for="image-align-right"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="alignright"/>
                          </label>
                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          class="checkbox-button-wrapper radio-button-wrapper position-relative"
                        >
                          <input
                            id="align-top"
                            :checked="getObjectCanvasAlignment.verticalAlignment == 'top'"
                            type="radio"
                            name="alignment-vertical"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('top',productCrop)">
                          <label
                            v-tooltip="'Top'"
                            for="align-top"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="aligntop"/>
                          </label>

                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          class=" checkbox-button-wrapper radio-button-wrapper position-relative"
                        >
                          <input
                            id="vertical-align-middle"
                            :checked="getObjectCanvasAlignment.verticalAlignment == 'center'"
                            type="radio"
                            name="alignment-vertical"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('middle',productCrop)">
                          <label
                            v-tooltip="'Middle'"
                            for="vertical-align-middle"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="alignmiddle"/>
                          </label>
                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          class=" checkbox-button-wrapper radio-button-wrapper position-relative"
                        >
                          <input
                            id="vertical-align-bottom"
                            :checked="getObjectCanvasAlignment.verticalAlignment === 'bottom'"
                            type="radio"
                            name="alignment-vertical"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('bottom',productCrop)">
                          <label
                            v-tooltip="'Align Bottom'"
                            for="vertical-align-bottom"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="alignbottom"/>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--Alignment-Button-End--->
                  <!---Rotate - Flip - Start-->
                  <div
                    class="d-flex mt-20">
                    <div class="rotate-flip-margin">
                      <div class="mb-8">
                        <span class="text-box-images">Rotate</span>
                      </div>
                      <div class="d-flex ">
                        <div class="button-box-images me-12">
                          <div
                            id="21"
                            class="unchecked-box position-relative"
                          >
                            <input
                              id="rotate-left"
                              type="radio"
                              name="rotate"
                              class="checkmark position-absolute"
                              value="align-middle">
                            <label
                              v-tooltip="'Left'"
                              for="rotate-left"
                              class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center "
                              @click="rotateLeft">
                              <icon name="rotateleft"/>
                            </label>
                          </div>
                        </div>
                        <div class="button-box-images me-12">
                          <div
                            id="22"
                            class="unchecked-box  position-relative"


                          >
                            <input
                              id="rotate-right"
                              type="radio"
                              name="rotate"
                              class="checkmark position-absolute"
                              value="align-middle">
                            <label
                              v-tooltip="'Right'"
                              for="rotate-right"
                              class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center "
                              @click="rotateRight">
                              <icon name="rotateright"/>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!---other alignment --->
                    <div>
                      <div class="mb-8">
                        <span class="text-box-images">Flip</span>
                      </div>
                      <div class="d-flex">
                        <div class="button-box-images me-12">
                          <div
                            id="23"
                            class="checkbox-button-wrapper radio-button-wrapper position-relative"
                          >
                            <input
                              id="flip-vertical"
                              :checked="activeObjectForLeftPanel.IsVFlipped"
                              type="checkbox"
                              class="checkmark position-absolute"
                              value="align-middle"
                              @change="flipVertical()">
                            <label
                              v-tooltip="'Flip Vertical'"
                              for="flip-vertical"
                              class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                              <icon name="flipvertical"/>
                            </label>
                          </div>
                        </div>
                        <div class="button-box-images me-12">
                          <div
                            id="24"
                            class="checkbox-button-wrapper radio-button-wrapper position-relative"

                          >
                            <input
                              id="flip-horizontal"
                              :checked="activeObjectForLeftPanel.IsHFlipped"
                              type="checkbox"
                              class="checkmark position-absolute"
                              value="align-middle"
                              @change="flipHorizontal()">
                            <label
                              v-tooltip="'Flip Horizontal'"
                              for="flip-horizontal"
                              class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                              <icon name="fliphorizontal"/>
                            </label>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <!---Rotate - Flip - End-->

                  <!---others---->
                  <div class="outer-box-images mt-20">

                    <div class="mb-8">
                      <span class="text-box-images">Other</span>
                    </div>

                    <div class="d-flex ">
                      <div class="button-box-images me-12 position-relative">
                        <div
                          v-tooltip="'Transparency'"
                          ref="transparencyButton"
                          :class="[popModal.isModalOpen ? 'colorActive' : '']"
                          class="bm-small-btns  d-flex justify-content-center align-items-center  "
                          @click.stop="openTransparencyModal($event)"
                        >
                          <icon name="transparency"/>

                        </div>
                        <div
                          ref="transparencyModal"
                          :style="getPopUpModalPositions"
                          :class="[popModal.isModalOpen ? 'd-block' : 'd-none !important']"
                          class="d-flex flex-row justify-content-between align-items-center px-20 py-16 transparency bg-white position-fixed rounded rounded-4 "
                          @click.stop>
                          <Slider
                            :name="ImageFilterTypes.OPACITY"
                            :is-image-effect="true"
                            :value="activeObjectForLeftPanel.effects.transparency.value"
                            class="py-3 w-100"
                            @updated="changeImageEffects" />

                        </div>

                      </div>
                      <div class="button-box-images me-12 position-relative ">
                        <div
                          v-tooltip="'Crop Image'"
                          v-if="!isSVG"
                          class="bm-small-btns  d-flex justify-content-center align-items-center"
                          @click="toggleCrop">
                          <icon name="cropimage"/>
                        </div>
                      </div>
                      <div
                        id="button-scale"
                        class="button-box-images me-12 position-relative"
                        @click.stop="toggleScalePop">
                        <div
                          v-tooltip="'Adjustments'"
                          v-if="!isSVG"
                          ref="adjustModalBtn"
                          :class="[isScaleOPen ? 'colorActive' : '']"
                          class="bm-small-btns  d-flex justify-content-center align-items-center  "
                        >
                          <icon name="adjustments"/>

                        </div>

                        <!---Scale Popupbox replacement --->
                        <div
                          ref="adjustModal"
                          :style="[getInitialPositions , getAdjustmentModalPosition]"
                          :class="[isScaleOPen ? 'show-outer-box' : 'invisible']"
                          class="outer-box d-flex flex-column  justify-content-center py-16 px-20"
                          @click.stop >
                          <Slider
                            :name="ImageFilterTypes.BRIGHTNESS"
                            :is-image-effect="true"
                            :value="activeObjectForLeftPanel.effects.brightness.value"
                            class="py-3"
                            @updated="changeImageEffects" />
                          <Slider
                            :name="ImageFilterTypes.CONTRAST"
                            :is-image-effect="true"
                            :value="activeObjectForLeftPanel.effects.contrast.value"
                            class="mt-12 py-3"
                            @updated="changeImageEffects"/>
                          <Slider
                            :name="ImageFilterTypes.SATURATION"
                            :is-image-effect="true"
                            :value="activeObjectForLeftPanel.effects.saturation.value"
                            class="mt-12 py-3"
                            @updated="changeImageEffects"/>
                          <Slider
                            :name="ImageFilterTypes.TINT"
                            :value="activeObjectForLeftPanel.effects.tint.value"
                            :show-color-picker="true"
                            :color="activeObjectForLeftPanel.effects.tint.color"
                            class="mt-12 py-3"
                            @updated="changeImageEffects"/>
                          <Slider
                            :name="ImageFilterTypes.BLUR"
                            :is-image-effect="true"
                            :value="activeObjectForLeftPanel.effects.blur.value"
                            class="mt-12 py-3"
                            @updated="changeImageEffects"/>
                          <Slider
                            :name="ImageFilterTypes.VIGNETTE"
                            :is-image-effect="true"
                            :value="activeObjectForLeftPanel.effects.vignette.value"
                            class="mt-12 py-3"
                            @updated="changeImageEffects"/>
                        </div>

                      </div>

                      <div
                          id="button-remove-bg"
                          class="button-box-images me-12 position-relative"
                          @click.stop="removeImageBackground">
                        <div
                            v-tooltip="'Remove background'"
                            v-if="!isSVG"
                            ref="adjustModalBtn"
                            :class="[isScaleOPen ? 'colorActive' : '']"
                            class="bm-small-btns  d-flex justify-content-center align-items-center  "
                        >
                          <icon name="bg-remover"/>

                        </div>

                      </div>

                      <!---other alignment --->
                    </div>
                  </div>
                  <!---others-Ends--->


                  <!--ImageGalleryList-->
                  <div class="outer-box-images mt-20">
                    <div>
                      <span class="text-box-images">Gallery</span>
                      <div class="d-flex flex-wrap mt-6">
                        <div
                          v-for="(imageSrc,i) in getAlternativeImageUrls"
                          :key="i+'-alt'"
                          class="me-12 mt-2 mb-10">
                          <div

                            :class="[activeObjectForLeftPanel.DefaultImageUrl === imageSrc.DefaultImageUrl ? 'border-blue-primary': 'border-4',intialImageBorder === activeObjectForLeftPanel.AlternativeImageUrls[i] ? 'border-blue-primary': 'border-4']"
                            class="button-box-thumbnail thumbnail-box rounded rounded-4 p-0  p-0  border-0"
                            @click.stop="replaceImage(imageSrc)">
                            <img
                              :src="'https://pdf-processing.bankmarketingcenter.com/node/image?width=36&height=36&resizeOnly=1&image='+imageSrc.DefaultImageUrl"
                              class="h-100 w-100 rounded-4">
                          </div>
                        </div>
                        <div
                          class="me-12 mt-2">
                          <button
                            class="icon-btn dotted-border add-new-btn custom-icon pagination-pill d-flex align-items-center justify-content-center hover-icon rounded rounded-4 py-0 px-10 bg-white border-0 btn-outline-0 "
                            @click="toggleImageModel">
                            <icon name="page-plus"/>
                          </button>
                          <!--                            <pagination-button-->
                          <!--                              id="11"-->
                          <!--                              button-type="icon-button"-->
                          <!--                              icon-name="plus2"-->
                          <!--                              class="hover-icon" />-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          :class="[toggleShapePanel ? 'icon-tilt' : '']"
          class="widget-inner py-12 px-16 expand-icon"
          @click.stop="toggleShapeSection">
          <panel-heading
            title="Shapes/Color"
            left-icon="shapes"
            right-icon="chevron"
            section="shape"/>
          <div
            v-if="getOpenPanel == LeftSectionPanelTypes.SHAPES ||getOpenPanel == LeftSectionPanelTypes.SVGIMAGE||toggleShapePanel"
            class="accordion-collapse">
            <div class="accordion-body p-0">
              <div class="bm-collapse Images color-selector shape-selector shapes mt-32 mb-8">
                <ul class="d-flex list-unstyled panel-buttons mb-0">
                  <li class="me-12 position-relative">
                    <button
                      v-tooltip="'Add Circle'"
                      id="28"
                      class="lf-btn btn-lightest-gray bm-bordered-btn position-relative  shadowed-btn"
                      @click.stop="addShapeObject('circle')">
                      <icon name="circle"/>
                    </button>
                  </li>

                  <li class="me-12 position-relative">
                    <button
                      v-tooltip="'Add Rectangle'"
                      id="29"
                      class="lf-btn btn-lightest-gray bm-bordered-btn position-relative  shadowed-btn"
                      @click.stop="addShapeObject('rectangle')">
                      <icon name="rectangle"/>
                    </button>
                  </li>

                  <li
                    v-if="0"
                    class="me-0 position-relative">
                    <button
                      v-tooltip="'Add Polygon'"
                      id="30"
                      class="lf-btn btn-lightest-gray
                       position-relative  shadowed-btn"
                      @click.stop="addShapeObject('polygon')">
                      <icon name="polygon"/>
                    </button>
                  </li>
                  <li
                    class="me-0 position-relative">
                    <button
                      class="pt-12 pb-12 d-flex shape-btn align-items-center btn-primary bm-primary-btn justify-content-center hover-icon rounded rounded-4"
                      @click="toggleShapeModel">
                      Shape Library</button>
                  </li>

                </ul>
              </div>

            </div>


            <div
              v-if="activeObject"
              class="separator-line mt-20 mb-10"/>
            <div
              v-if="activeObject"
              class="d-flex justify-content-center align-items-center w-100 flex-column">
              <div
                class="shape-color-tab w-100 pt-10 position-relative"
                @click="toggleShapeFillColorPanel">Fill Color
                <icon
                  :style="showShapeFillColorPanel ? {transform:`rotate(-90deg)`}:{}"
                  class="sub-menu-arrow"
                  name="chevron"/>
              </div>

              <color-picker
                v-if="showShapeFillColorPanel"
                :color="getColorLabelShape"
                :type="getObjectType"
                  :key="'color-picker-'+activeObject.Id+'-'+activeObject.isGradient+'-'+getSelectedPointOfGradient"
                  :active-object="activeObjectForLeftPanel"
                display-style="inline"
                  @updateSelectedPointOfGradient="updateSelectedPointOfGradient"
                  @updateSelectedPointPosition="updateSelectedPointPosition"
                  @changeMode="handleModeChange"
                  @updateSelectedGradientAngle="updateSelectedGradientAngle"
                color-type="fill"
              />
              <div
                class="shape-color-tab w-100 mb-5 position-relative"
                @click="toggleShapeStrokeColorPanel">Outline Color
                <icon
                  :style="showShapeStrokeColorPanel ? {transform:`rotate(-90deg)`}:{}"
                  name="chevron"
                  class="sub-menu-arrow" />
              </div>
              <div
                v-if="showShapeStrokeColorPanel"
                class="w-100 align-items-center flex-column d-flex">
                <div class="d-flex w-100 mt-20">
                  <div class="stroke-width-text">Stroke Width</div>
                  <div class="slider-container">
                    <input
                      id="myRange"
                      :style="{background:`linear-gradient(90deg, #3BB0FA ${activeObject.ImageType == 'SVGImage' ? activeObject.SvgProperty.StrokeWidth * 10 : activeObject.StrokeWidth * 10}%, #d6d6d6 0%)`}"
                      :min="0"
                      :max="10"
                      v-model="shapeStrokeWidth"
                      type="range"
                      class="slider w-100 rounded rounded-12 btn-outline-0"
                    >
                  </div>
                </div>

                <color-picker
                  :color="getStrokeColorLabelShape"
                  :type="getObjectType"
                  :key="'color-picker-stroke-'+activeObject.Id"
                  display-style="inline"
                  color-type="outline"
                />
              </div>


            </div>
            <div
              v-if="activeObjectForLeftPanel"
              class="outer-box-images canvas-position-controls">
              <div class="mb-8">
                <span class="text-box-images">Position</span>
              </div>
              <div class="d-flex ">
                <div class="button-box-images me-12">
                  <div
                    class=" position-relative checkbox-button-wrapper radio-button-wrapper">
                    <input
                      id="image-align-left"
                      :checked="getObjectCanvasAlignment.horizontalAlignment == 'left'"
                      type="radio"
                      name="alignment-horizontal"
                      class="checkmark position-absolute"
                      value="align-middle"
                      @change="alignObjectPosition('left',productCrop)">
                    <label
                      v-tooltip="'Left'"
                      for="image-align-left"
                      class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                      <icon name="alignleft"/>
                    </label>
                  </div>
                </div>
                <div class="button-box-images me-12">
                  <div
                    class="position-relative checkbox-button-wrapper radio-button-wrapper">
                    <input
                      id="align-middle"
                      :checked="getObjectCanvasAlignment.horizontalAlignment == 'center'"
                      type="radio"
                      name="alignment-horizontal"
                      class="checkmark position-absolute"
                      value="align-middle"
                      @change="alignObjectPosition('center',productCrop)">
                    <label
                      v-tooltip="'Center'"
                      for="align-middle"
                      class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                      <icon name="aligncenter"/>
                    </label>
                  </div>
                </div>
                <div class="button-box-images me-12">
                  <div
                    class=" checkbox-button-wrapper radio-button-wrapper position-relative">
                    <input
                      id="image-align-right"
                      :checked="getObjectCanvasAlignment.horizontalAlignment == 'right'"
                      type="radio"
                      name="alignment-horizontal"
                      class="checkmark position-absolute"
                      value="align-middle"
                      @change="alignObjectPosition('right',productCrop)">
                    <label
                      v-tooltip="'Right'"
                      for="image-align-right"
                      class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                      <icon name="alignright"/>
                    </label>
                  </div>
                </div>
                <div class="button-box-images me-12">
                  <div
                    class="checkbox-button-wrapper radio-button-wrapper position-relative"
                  >
                    <input
                      id="align-top"
                      :checked="getObjectCanvasAlignment.verticalAlignment == 'top'"
                      type="radio"
                      name="alignment-vertical"
                      class="checkmark position-absolute"
                      value="align-middle"
                      @change="alignObjectPosition('top',productCrop)">
                    <label
                      v-tooltip="'Top'"
                      for="align-top"
                      class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                      <icon name="aligntop"/>
                    </label>

                  </div>
                </div>
                <div class="button-box-images me-12">
                  <div
                    class=" checkbox-button-wrapper radio-button-wrapper position-relative"
                  >
                    <input
                      id="vertical-align-middle"
                      :checked="getObjectCanvasAlignment.verticalAlignment == 'center'"
                      type="radio"
                      name="alignment-vertical"
                      class="checkmark position-absolute"
                      value="align-middle"
                      @change="alignObjectPosition('middle',productCrop)">
                    <label
                      v-tooltip="'Middle'"
                      for="vertical-align-middle"
                      class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                      <icon name="alignmiddle"/>
                    </label>
                  </div>
                </div>
                <div class="button-box-images me-12">
                  <div
                    class=" checkbox-button-wrapper radio-button-wrapper position-relative"
                  >
                    <input
                      id="vertical-align-bottom"
                      :checked="getObjectCanvasAlignment.verticalAlignment === 'bottom'"
                      type="radio"
                      name="alignment-vertical"
                      class="checkmark position-absolute"
                      value="align-middle"
                      @change="alignObjectPosition('bottom',productCrop)">
                    <label
                      v-tooltip="'Align Bottom'"
                      for="vertical-align-bottom"
                      class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                      <icon name="alignbottom"/>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="activeObjectForLeftPanel"
              class="d-flex mt-20 ">
              <div class="rotate-flip-margin">
                <div class="mb-8">
                  <span class="text-box-images">Rotate</span>
                </div>
                <div class="d-flex ">
                  <div class="button-box-images me-12">
                    <div
                      id="21"
                      class="unchecked-box position-relative"
                    >
                      <input
                        id="rotate-left"
                        type="radio"
                        name="rotate"
                        class="checkmark position-absolute"
                        value="align-middle">
                      <label
                        v-tooltip="'Left'"
                        for="rotate-left"
                        class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center "
                        @click="rotateLeft">
                        <icon name="rotateleft"/>
                      </label>
                    </div>
                  </div>
                  <div class="button-box-images me-12">
                    <div
                      id="22"
                      class="unchecked-box  position-relative"


                    >
                      <input
                        id="rotate-right"
                        type="radio"
                        name="rotate"
                        class="checkmark position-absolute"
                        value="align-middle">
                      <label
                        v-tooltip="'Right'"
                        for="rotate-right"
                        class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center "
                        @click="rotateRight">
                        <icon name="rotateright"/>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <!---other alignment --->
              <div>
                <div class="mb-8">
                  <span class="text-box-images">Flip</span>
                </div>
                <div class="d-flex">
                  <div class="button-box-images me-12">
                    <div
                      id="23"
                      class="checkbox-button-wrapper radio-button-wrapper position-relative"
                    >
                      <input
                        id="flip-vertical"
                        :checked="activeObjectForLeftPanel.IsVFlipped"
                        type="checkbox"
                        class="checkmark position-absolute"
                        value="align-middle"
                        @change="flipVertical()">
                      <label
                        v-tooltip="'Flip Vertical'"
                        for="flip-vertical"
                        class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                        <icon name="flipvertical"/>
                      </label>
                    </div>
                  </div>
                  <div class="button-box-images me-12">
                    <div
                      id="24"
                      class="checkbox-button-wrapper radio-button-wrapper position-relative"

                    >
                      <input
                        id="flip-horizontal"
                        :checked="activeObjectForLeftPanel.IsHFlipped"
                        type="checkbox"
                        class="checkmark position-absolute"
                        value="align-middle"
                        @change="flipHorizontal()">
                      <label
                        v-tooltip="'Flip Horizontal'"
                        for="flip-horizontal"
                        class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                        <icon name="fliphorizontal"/>
                      </label>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="isVideoMoodOn"
          class="widget-inner py-12 px-16">
          <panel-heading
            :section="LeftSectionPanelTypes.Video"
            :product-width="width"
            :product-height="height"
            title="Video"
            section="Video"
            left-icon="video-icon"
          />
          <div
            v-if="getOpenPanel == LeftSectionPanelTypes.Video"
            class="accordion-collapse">
            <div class="accordion-body p-0">
              <div class="bm-collapse Images color-selector shape-selector">
                <div class="main-box mt-32 mb-8">
                  <div class="outer-box-images">
                    <div class="mb-8">
                      <span class="text-box-images">Position</span>
                    </div>
                    <div class="d-flex ">
                      <div class="button-box-images me-12">
                        <div
                          class=" position-relative checkbox-button-wrapper radio-button-wrapper">
                          <input
                            id="image-align-left"
                            :checked="getObjectCanvasAlignment.horizontalAlignment == 'left'"
                            type="radio"
                            name="alignment-horizontal"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('left',productCrop)">
                          <label
                            v-tooltip="'Left'"
                            for="image-align-left"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="alignleft"/>
                          </label>
                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          class="position-relative checkbox-button-wrapper radio-button-wrapper">
                          <input
                            id="align-middle"
                            :checked="getObjectCanvasAlignment.horizontalAlignment == 'center'"
                            type="radio"
                            name="alignment-horizontal"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('center',productCrop)">
                          <label
                            v-tooltip="'Center'"
                            for="align-middle"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="aligncenter"/>
                          </label>
                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          class=" checkbox-button-wrapper radio-button-wrapper position-relative">
                          <input
                            id="image-align-right"
                            :checked="getObjectCanvasAlignment.horizontalAlignment == 'right'"
                            type="radio"
                            name="alignment-horizontal"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('right',productCrop)">
                          <label
                            v-tooltip="'Right'"
                            for="image-align-right"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="alignright"/>
                          </label>
                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          class="checkbox-button-wrapper radio-button-wrapper position-relative"
                        >
                          <input
                            id="align-top"
                            :checked="getObjectCanvasAlignment.verticalAlignment == 'top'"
                            type="radio"
                            name="alignment-vertical"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('top',productCrop)">
                          <label
                            v-tooltip="'Top'"
                            for="align-top"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="aligntop"/>
                          </label>

                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          class=" checkbox-button-wrapper radio-button-wrapper position-relative"
                        >
                          <input
                            id="vertical-align-middle"
                            :checked="getObjectCanvasAlignment.verticalAlignment == 'center'"
                            type="radio"
                            name="alignment-vertical"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('middle',productCrop)">
                          <label
                            v-tooltip="'Middle'"
                            for="vertical-align-middle"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="alignmiddle"/>
                          </label>
                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          class=" checkbox-button-wrapper radio-button-wrapper position-relative"
                        >
                          <input
                            id="vertical-align-bottom"
                            :checked="getObjectCanvasAlignment.verticalAlignment === 'bottom'"
                            type="radio"
                            name="alignment-vertical"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('bottom',productCrop)">
                          <label
                            v-tooltip="'Align Bottom'"
                            for="vertical-align-bottom"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="alignbottom"/>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--Alignment-Button-End--->
                  <!---Rotate - Flip - Start-->
                  <div
                    v-if="!isSVG"
                    class="d-flex mt-20">
                    <div class="rotate-flip-margin">
                      <div class="mb-8">
                        <span class="text-box-images">Rotate</span>
                      </div>
                      <div class="d-flex ">
                        <div class="button-box-images me-12">
                          <div
                            id="21"
                            class="unchecked-box position-relative"
                          >
                            <input
                              id="rotate-left"
                              type="radio"
                              name="rotate"
                              class="checkmark position-absolute"
                              value="align-middle">
                            <label
                              v-tooltip="'Left'"
                              for="rotate-left"
                              class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center "
                              @click="rotateLeft">
                              <icon name="rotateleft"/>
                            </label>
                          </div>
                        </div>
                        <div class="button-box-images me-12">
                          <div
                            id="22"
                            class="unchecked-box  position-relative"


                          >
                            <input
                              id="rotate-right"
                              type="radio"
                              name="rotate"
                              class="checkmark position-absolute"
                              value="align-middle">
                            <label
                              v-tooltip="'Right'"
                              for="rotate-right"
                              class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center "
                              @click="rotateRight">
                              <icon name="rotateright"/>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!---other alignment --->
                    <div>
                      <div class="mb-8">
                        <span class="text-box-images">Flip</span>
                      </div>
                      <div class="d-flex">
                        <div class="button-box-images me-12">
                          <div
                            id="23"
                            class="checkbox-button-wrapper radio-button-wrapper position-relative"
                          >
                            <input
                              id="flip-horizontal"
                              type="checkbox"
                              class="checkmark position-absolute"
                              value="align-middle"
                              @change="flipVertical()">
                            <label
                              v-tooltip="'Flip Vertical'"
                              for="flip-horizontal"
                              class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                              <icon name="fliphorizontal"/>
                            </label>
                          </div>
                        </div>
                        <div class="button-box-images me-12">
                          <div
                            id="24"
                            class="checkbox-button-wrapper radio-button-wrapper position-relative"

                          >
                            <input
                              id="flip-vertical"
                              type="checkbox"
                              class="checkmark position-absolute"
                              value="align-middle"
                              @change="flipHorizontal()">
                            <label
                              v-tooltip="'Flip Horizontal'"
                              for="flip-vertical"
                              class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                              <icon name="flipvertical"/>
                            </label>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <!---Rotate - Flip - End-->

                  <!---others---->
                  <div class="outer-box-images mt-20">

                    <div class="mb-8">
                      <span class="text-box-images">Other</span>
                    </div>

                    <div class="d-flex ">
                      <div class="button-box-images me-12 position-relative">
                        <div
                          v-tooltip="'Transparency'"
                          ref="transparencyButton"
                          :class="[popModal.isModalOpen ? 'colorActive' : '']"
                          class="bm-small-btns  d-flex justify-content-center align-items-center  "
                          @click.stop="openTransparencyModal($event)"
                        >
                          <icon name="transparency"/>

                        </div>
                        <div
                          ref="transparencyModal"
                          :style="getPopUpModalPositions"
                          :class="[popModal.isModalOpen ? 'd-block' : 'd-none !important']"
                          class="d-flex flex-row justify-content-between align-items-center px-20 py-16 transparency bg-white position-fixed rounded rounded-4 "
                          @click.stop>
                          <Slider
                            :name="ImageFilterTypes.OPACITY"
                            :is-image-effect="true"
                            :value="activeObjectForLeftPanel.effects.transparency.value"
                            class="py-3 w-100"
                            @updated="changeImageEffects" />

                        </div>

                      </div>
                      <!-- <div class="button-box-images me-12 position-relative ">
                        <div
                          v-tooltip="'Crop Image'"
                          v-if="!isSVG"
                          class="bm-small-btns  d-flex justify-content-center align-items-center"
                          @click="toggleCrop">
                          <icon name="cropimage"/>
                        </div>
                      </div> -->
                      <div
                        id="button-scale"
                        class="button-box-images me-12 position-relative"
                        @click.stop="toggleScalePop">
                        <div
                          v-tooltip="'Adjustments'"
                          v-if="!isSVG"
                          ref="adjustModalBtn"
                          :class="[isScaleOPen ? 'colorActive' : '']"
                          class="bm-small-btns  d-flex justify-content-center align-items-center  "
                        >
                          <icon name="adjustments"/>

                        </div>

                        <!---Scale Popupbox replacement --->
                        <div
                          ref="adjustModal"
                          :style="[getInitialPositions , getAdjustmentModalPosition]"
                          :class="[isScaleOPen ? 'show-outer-box' : 'invisible']"
                          class="outer-box d-flex flex-column  justify-content-center py-16 px-20"
                          @click.stop >
                          <Slider
                            :name="ImageFilterTypes.BRIGHTNESS"
                            :is-image-effect="true"
                            :value="activeObjectForLeftPanel.effects.brightness.value"
                            class="py-3"
                            @updated="changeImageEffects" />
                          <Slider
                            :name="ImageFilterTypes.CONTRAST"
                            :is-image-effect="true"
                            :value="activeObjectForLeftPanel.effects.contrast.value"
                            class="mt-12 py-3"
                            @updated="changeImageEffects"/>
                          <Slider
                            :name="ImageFilterTypes.SATURATION"
                            :is-image-effect="true"
                            :value="activeObjectForLeftPanel.effects.saturation.value"
                            class="mt-12 py-3"
                            @updated="changeImageEffects"/>
                          <Slider
                            :name="ImageFilterTypes.TINT"
                            :value="activeObjectForLeftPanel.effects.tint.value"
                            :show-color-picker="true"
                            :color="activeObjectForLeftPanel.effects.tint.color"
                            class="mt-12 py-3"
                            @updated="changeImageEffects"/>
                          <Slider
                            :name="ImageFilterTypes.BLUR"
                            :is-image-effect="true"
                            :value="activeObjectForLeftPanel.effects.blur.value"
                            class="mt-12 py-3"
                            @updated="changeImageEffects"/>
                          <Slider
                            :name="ImageFilterTypes.VIGNETTE"
                            :is-image-effect="true"
                            :value="activeObjectForLeftPanel.effects.vignette.value"
                            class="mt-12 py-3"
                            @updated="changeImageEffects"/>
                        </div>

                      </div>
                      <div class="button-box-images me-12 position-relative ">
                        <div
                          v-tooltip="'Trim Video'"
                          v-if="!isSVG"
                          class="bm-small-btns d-flex justify-content-center align-items-center"
                          @click="toggleTrim">
                          <icon name="trim"/>
                        </div>
                      </div>

                      <!---other alignment --->
                    </div>
                  </div>
                  <!---others-Ends--->

                  <div class="outer-box-images mt-20">
                    <div>
                      <span class="text-box-images">Gallery</span>
                      <div class="d-flex flex-wrap mt-6">
                        <div
                          v-for="(video,i) in getAlternativeVideoUrls"
                          :key="i+'-alt'"
                          class="me-12 mt-2 mb-10">
                          <div

                            :class="[activeObjectForLeftPanel.DefaultImageUrl === video.ThumbnailVirtualPath ? 'border-blue-primary': 'border-4']"
                            class="button-box-thumbnail thumbnail-box rounded rounded-4 p-0  p-0  border-0"
                            @click.stop="replaceVideo(video)">
                            <img
                              :src="'https://pdf-processing.bankmarketingcenter.com/node/image?width=36&height=36&resizeOnly=1&image='+video.ThumbnailVirtualPath"
                              class="h-100 w-100 rounded-4">
                          </div>
                        </div>
                        <div
                          class="me-12 mt-2">
                          <button
                            class="icon-btn dotted-border add-new-btn custom-icon pagination-pill d-flex align-items-center justify-content-center hover-icon rounded rounded-4 py-0 px-10 bg-white border-0 btn-outline-0 "
                            @click="toggleVideoModel">
                            <icon name="page-plus"/>
                          </button>
                          <!--                            <pagination-button-->
                          <!--                              id="11"-->
                          <!--                              button-type="icon-button"-->
                          <!--                              icon-name="plus2"-->
                          <!--                              class="hover-icon" />-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="widget-inner py-12 px-16">
          <panel-heading
            :product-height = "height"
            :product-width = "width"
            :product-address-boxes ="getProductAddressBoxes"
            :section = "LeftSectionPanelTypes.ADDRESS"
            title="Address"
            left-icon="address"
          />
          <div
            v-if="getOpenPanel == LeftSectionPanelTypes.ADDRESS"
            class="panel-collapse">
            <div class="panel-body p-0">
              <div class="bm-collapse Images color-selector shape-selector mt-32 mb-8">
                <div class="color-select-buttons-wrapper d-flex justify-content-between flex-column">
                  <div class="outer-box-images">
                    <div class="mb-8">
                      <span class="text-box-images">Position</span>
                    </div>
                    <div class="d-flex ">
                      <div class="button-box-images me-12">
                        <div
                          id="15"
                          class="checkbox-button-wrapper radio-button-wrapper position-relative">
                          <input

                            id="address-align-left"
                            :checked="getObjectCanvasAlignment.horizontalAlignment === 'left'"
                            type="radio"
                            name="alignment-horizontal"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('left',productCrop)">
                          <label
                            v-tooltip="'Align Left'"
                            for="address-align-left"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="alignleft"/>
                          </label>

                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          id="16"
                          class="checkbox-button-wrapper radio-button-wrapper position-relative"

                        >
                          <input
                            id="addres-align-center"
                            :checked="getObjectCanvasAlignment.horizontalAlignment === 'center'"
                            type="radio"
                            name="alignment-horizontal"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('center',productCrop)">
                          <label
                            v-tooltip="'Align Center'"
                            for="addres-align-center"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="aligncenter"/>
                          </label>

                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          id="17"
                          class="checkbox-button-wrapper radio-button-wrapper position-relative"

                        >
                          <input
                            id="address-vertical-align-right"
                            :checked="getObjectCanvasAlignment.horizontalAlignment === 'right'"
                            type="radio"
                            name="alignment-horizontal"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('right',productCrop)">
                          <label
                            v-tooltip="'Align Right'"
                            for="address-vertical-align-right"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="alignright"/>
                          </label>
                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          id="18"
                          class="checkbox-button-wrapper radio-button-wrapper position-relative">
                          <input
                            id="address-align-top"
                            :checked="getObjectCanvasAlignment.verticalAlignment === 'top'"
                            type="radio"
                            name="alignment-vertical"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('top',productCrop)">
                          <label
                            v-tooltip="'Align Top'"
                            for="address-align-top"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="aligntop"/>
                          </label>

                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          id="19"
                          class="checkbox-button-wrapper radio-button-wrapper position-relative"
                        >
                          <input
                            id="address-vertical-align-middle"
                            :checked="getObjectCanvasAlignment.verticalAlignment === 'center'"
                            type="radio"
                            name="alignment-vertical"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('middle',productCrop)">
                          <label
                            v-tooltip="'Align Middle'"
                            for="address-vertical-align-middle"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="alignmiddle"/>
                          </label>

                        </div>
                      </div>
                      <div class="button-box-images me-12">
                        <div
                          id="20"
                          class="checkbox-button-wrapper radio-button-wrapper position-relative"

                        >
                          <input
                            id="address-vertical-align-bottom"
                            :checked="getObjectCanvasAlignment.verticalAlignment === 'bottom'"
                            type="radio"
                            name="alignment-vertical"
                            class="checkmark position-absolute"
                            value="align-middle"
                            @change="alignObjectPosition('bottom',productCrop)">
                          <label
                            v-tooltip="'Align Bottom'"
                            for="address-vertical-align-bottom"
                            class=" bm-small-btns custom-icon d-flex align-items-center justify-content-center ">
                            <icon name="alignbottom"/>
                          </label>

                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="address-box-wrapper mt-24 mb-4">
                    <div
                      v-for="(AddressBoxes, i) in getProductAddressBoxes"
                      :key="'address-'+i"
                      class="address-boxes d-flex justify-content-center align-items-center border px-10 py-10 my-10 bg-lightest-gray"
                      style="max-width: 344px"
                      @click.stop="replaceAddressBoxImage(AddressBoxes)">
                      <img
                        :src="AddressBoxes.DefaultImagePath"
                        style="width: 100%">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="1"
          class="widget-inner py-12 px-16">
          <panel-heading
            :section="LeftSectionPanelTypes.QRCODE"
            title="QR Code"
            left-icon="qrcode"/>
        </div>
        <audio-component
          v-if="isVideoMoodOn"
          :product="product"
        />
      </div>
      <div
        v-else
        class="main-widget-wrapper scroller h-100">
        <animation-panel
          :product="product"
          :active-page="activePage"
          :active-object="getActiveObject"/>
      </div>
    </div>
    <bg-remover v-if="$store.getters.getIsBgRemoverOpen" :activeObject="activeObject"/>
  </div>
</template>
<script>

import _ from 'lodash';
import PanelHeading from '@/components/PanelHeading/PanelHeading';
import ColorSelectButton from '@/components/ColorSelectButton/ColorSelectButton';
import TextField from '@/components/TextField/TextField';
import UtilityButtonsPanel from '@/components/UtiltyButtonsPanel/UtiltyButtonsPanel';
import FontFamilySelector from '@/components/FontFamilySelector/FontFamilySelector';
import SizeAdjustButton from '@/components/SizeAdjustButton/SizeAdjustButton';
import ColorSelector from '@/components/ColorSelector/ColorSelector';
import PanelButtons from '@/components/PanelButtons/PanelButtons';
import ProductPageSize from '@/components/ProductPageSize/ProductPageSize';
import EventBus from '@/EventBus';
import CollapsiblePanel from '@/components/CollapsiblePanel/CollapsiblePanel';
import { TinyMCECommandTypes, TextCommandTypes } from '@/mixins/TextCommandTypes';
import LeftSectionPanelTypes from '@/mixins/LeftSectionPanelTypes';
import ImageFilterTypes from '@/mixins/ImageFilterTypes';
import ColorPicker from '@/components/ColorPicker/ColorPicker';
import paginationbutton from '@/components/PaginationButton/PaginationButton';
import Slider from '@/components/Slider/Slider';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes'; // TDOD: Change to @/
import AudioComponent from '@/components/Audio/AudioComponent';
import BackgroundObject from '@/components/DesignObjects/BackgroundObject';
import ImageObject from '@/components/DesignObjects/ImageObject';
import {getMaxZIndex, removeBackground} from '@/components/Helper';
import { uuid } from 'vue-uuid';
import ElementAnimationMixin from '@/mixins/ElementAnimation';
import AnimationPanel from '../AnimationPanel/AnimationPanel';
// import AnimationTypes from '@/mixins/AnimationTypes';
import BgRemoverModal from "@/components/BgRemover/BgRemoverModal.vue";
import axios from "axios";


export default {
  name:       'LeftSection',
  components: {
    'panel-heading':         PanelHeading,
    'color-select-button':   ColorSelectButton,
    'text-field':            TextField,
    'utility-buttons-panel': UtilityButtonsPanel,
    'font-family-select':    FontFamilySelector,
    'size-adjust-button':    SizeAdjustButton,
    'color-selector':        ColorSelector,
    'color-picker':          ColorPicker,
    'pagination-button':     paginationbutton,
    'panel-button':          PanelButtons,
    'collapsible-panel':     CollapsiblePanel,
    'Product-Page-Size':     ProductPageSize,
    'animation-panel':       AnimationPanel,
    Slider,
    'audio-component':       AudioComponent,
    'bg-remover': BgRemoverModal
  },
  mixins: [LeftSectionPanelTypes.Mixin, TextCommandTypes.Mixin, TinyMCECommandTypes.Mixin, ImageFilterTypes.Mixin, ElementAnimationMixin],
  props:  {
    product:             Object,
    activePage:          Number,
    productCrop:         Object,
    activeObject:        Object,
    width:               Number,
    height:              Number,
    ProductAddressBoxes: Array,
    isProductCrop:       Object,
    productSize:         Object,
    contentList:         { Object, Array },
    isAlignmentGuideOn:  Boolean,
    isGrayScaleOn:       Boolean,
    checkModalOpen:      Boolean,
    isRulerOn:           Boolean,
    isOpenDetailSection: Boolean,
    isProductSizeRatio:  Boolean,
    productName:         String,
    isInch:              Boolean,
    bankType:            String,
  },

  data() {
    return {
      isFavouriteSize:      false,
      adjustModalPosition:  { y: 0 },
      // /productCropParam     :    this.productCrop,
      toggleShapePanel:     false,
      toggleAnimationPanel: false,
      detailsSection:       true,
      isNumberField:        true,
      isToggledOn:          false,
      initialSizeValue:     24, // TODO: convert to int
      initialSpacingValue:  0, // TODO: convert to int
      isAddress:            true,
      selectedButton:       -1,
      isSelected:           false,
      adjustmentInitialPos: {
        leftscalepop: 0,
        topscalepop:  0,
      },
      isScaleOPen:       false,
      hexcolorvalue:     '#000000',
      isTooltipShown:    false,
      selectedBox:       -1,
      intialImageBorder: '',
      isDropdownShown:   false,
      invalidKeyInput:   '',
      selectedOption:    'Pixels',
      valuechange:       'Inches',
      isBtnActive:       false,
      activeSubPanel:    '',
      direction:         '',
      speed:             50,
      onEnterAnimate:    false,
      onExitAnimate:     false,
      bothAnimate:       false,
      popModal:          {
        isModalOpen: false,
        position:    {
          x: 0,
          y: 0,
        },
      },
      isAdjustmentButtonActive:  false,
      showShapeStrokeColorPanel: false,
      showShapeFillColorPanel:   true,
      activePageAnimation:       null,
      toggleAudioPanel:          false,
      videoHelpChecked:          false,
      localStorage,
      isColorPickerOpen: false
    };
  },


  computed: {
    getLinearGradientNumber() {
      return ((this.activeObjectForLeftPanel.outLine.strokeWidth - 0.2) / 1.8 * 100);
    },
    getSelectedPointOfGradient() {
      return this.activeObjectForLeftPanel.gradient.colors.find((color) => color.isSelected).id
    },
    checkProductPagesAreInSameDimension() {
      let same = true;
      if (!this.product) {
        same = true;
      }
      if (this.product) {
        this.product.pages.forEach((page, i) => {
          if (i > 0) {
            if (this.product.pages[i - 1].width !== page.width) {
              console.log('widths not same');
              same = false;
            }
            if (this.product.pages[i - 1].height !== page.height) {
              console.log('heights not same');
              same = false;
            }
          }
        });
      }
      return same;
    },
    isVideoMoodOn() {
      return this.product && this.product.isVideo;
    },
    getDisplayAnimationPanel() {
      let display = true;
      if (this.activeObject) {
        display = true;
      }
      return this.$store.getters['activeProduct/getDisplayAnimationPanel'] && display;
    },
    shapeStrokeWidth: {
      get() {
        return this.activeObject.ImageType == 'SVGImage' ? this.activeObject.SvgProperty.StrokeWidth : this.activeObject.StrokeWidth;
      },
      set(value) {
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_STROKE_WIDTH, value);
      },
    },
    activeObjectForLeftPanel() {
      return this.activeObject;
    },
    isSnappingEnabled() {
      return this.$store.getters.getSnappingEnabled;
    },
    getSelectedPageWidth() {
      return this.productSize.width;
    },
    getSelectedPageHeight() {
      return this.productSize.height;
    },
    isHealthCareMarketingCenter() {
      return this.$store.getters.getBMCInstance !== 'healthcaremarketingcenter';
    },
    getProductAddressBoxes() {
      return this.ProductAddressBoxes;
    },
    getColorLabelShape() {
      if (this.activeObjectForLeftPanel.type == 'image' && this.activeObjectForLeftPanel.ImageType == 'SVGImage' && !this.activeObjectForLeftPanel.isGradient)
      {
        return this.activeObjectForLeftPanel.SvgProperty.DefaultColor;
      }
      return this.activeObjectForLeftPanel && this.activeObjectForLeftPanel.isGradient ? this.activeObjectForLeftPanel.gradient.colors.find((color) => color.isSelected).rgba : this.activeObjectForLeftPanel ? this.activeObjectForLeftPanel.DefaultColor : '#000';
    },
    getStrokeColorLabelShape() {
      console.log();
      if (this.activeObjectForLeftPanel.type == 'image' && this.activeObjectForLeftPanel.ImageType == 'SVGImage') { return this.activeObjectForLeftPanel.SvgProperty.StrokeColor; }
      return this.activeObjectForLeftPanel ? this.activeObjectForLeftPanel.StrokeColor : '#000';
    },
    getObjectType() {
      if (this.activeObjectForLeftPanel.type == 'text') { return this.activeObjectForLeftPanel.type; }
      if (this.activeObjectForLeftPanel.type == 'image') { return this.activeObjectForLeftPanel.ImageType; }
      if (this.activeObjectForLeftPanel.type == 'shape') { return this.activeObjectForLeftPanel.type; }
    },
    getActiveObject: {
      get() {
        return this.activeObject;
      },
      set(value) {
        this.activeObject = value;
      },
    },
    getPopUpModalPositions() {
      return {
        left: `${this.popModal.position.x}px`,
        top:  `${this.popModal.position.y}px`,
      };
    },

    getAdjustmentModalPosition() {
      return { top: `${this.adjustmentInitialPos.topscalepop}px !important` };
    },

    getAlternativeImageUrls() {
      // if(this.activeObjectForLeftPanel.AlternativeImageUrlsResVersion.length == 0) return this.activeObjectForLeftPanel.AlternativeImageUrls
      return this.activeObjectForLeftPanel.AlternativeImageUrlsResVersion;
    },

    getAlternativeVideoUrls() {
      return this.activeObjectForLeftPanel.AlternativeVideoUrlsResVersion;
    },

    getInitialPositions() {
      return {
        left: `${this.adjustmentInitialPos.leftscalepop + 50}px`,
        top:  `${this.adjustmentInitialPos.topscalepop}px`,
      };
    },
    isSVG() {
      console.log('active object is ', this.activeObjectForLeftPanel);
      if (this.activeObjectForLeftPanel.type == 'image') {
        try {
          const path = this.activeObjectForLeftPanel.DefaultImageUrl;
          if (path && path.split(/[#?]/)[0].split('.').pop().trim() == 'svg') {
            return true;
          }
        } catch (ex) {
          console.log('issue in getting object type', ex.message);
        }
      }
      return false;
    },
    getTopScalePopup() {

    },

    getOpenPanel() {
      this.toggleShapePanel = false;
      const selectedObjects = this.contentList.filter(obj => obj.isSelected);
      if (!this.activeObjectForLeftPanel || selectedObjects.length > 1) { return this.LeftSectionPanelTypes.NONE; }
      if (this.activeObjectForLeftPanel.type == 'text') { return this.LeftSectionPanelTypes.TEXT; }
      if (this.activeObjectForLeftPanel.ImageType == 'Image') { return this.LeftSectionPanelTypes.Image; }
      if (this.activeObjectForLeftPanel.ImageType == 'FDICText' || this.activeObjectForLeftPanel.ImageType == 'FDICTextWhite') { return this.LeftSectionPanelTypes.FDIC; } // FDIC use type FDICText for black color and other for white color
      if (this.activeObjectForLeftPanel.ImageType == 'WhiteboxLogo' || this.activeObjectForLeftPanel.ImageType == 'IndependentWhitebox') { return this.LeftSectionPanelTypes.ADDRESS; }
      if (this.activeObjectForLeftPanel.ImageType == 'FDICLogo' || this.activeObjectForLeftPanel.ImageType == 'FDICLogoWhite') { return this.LeftSectionPanelTypes.HOUSING; }
      if (this.activeObjectForLeftPanel.ImageType == 'SVGImage') {
        this.showShapeFillColorPanel   = true;
        this.showShapeStrokeColorPanel = false;
        return this.LeftSectionPanelTypes.SVGIMAGE;
      }
      if (this.activeObjectForLeftPanel.type == 'shape') {
        this.showShapeFillColorPanel   = true;
        this.showShapeStrokeColorPanel = false;
        return this.LeftSectionPanelTypes.SHAPES;
      }
      if (this.activeObjectForLeftPanel.type == 'video') { return this.LeftSectionPanelTypes.Video; }
      return this.LeftSectionPanelTypes.NONE;
    },
    getFontSize() {
      return (this.activeObjectForLeftPanel) && parseFloat(this.activeObjectForLeftPanel.valuesForLeftPanel.fontSize);
    },
    getFontFamily() {
      return (this.activeObjectForLeftPanel) && this.activeObjectForLeftPanel.valuesForLeftPanel.fontFamily;
    },
    isEditorEnable() {
      return !this.activeObjectForLeftPanel.isEditorEnable;
    },
    getColorLabel() {
      return (this.activeObjectForLeftPanel) && this.activeObjectForLeftPanel.valuesForLeftPanel.color;
    },
    getFontStyleBold: {
      get() {
        return this.activeObjectForLeftPanel.valuesForLeftPanel.isBold;
      },
      set(newValue) {
        this.activeObjectForLeftPanel.valuesForLeftPanel.isBold = newValue;
      },
    },

    getFontStyleItalic: {
      get() {
        return this.activeObjectForLeftPanel.valuesForLeftPanel.isItalic;
      },
      set(newValue) {
        this.activeObjectForLeftPanel.valuesForLeftPanel.isItalic = newValue;
      },
    },
    getFontStyleUnderline: {
      get() {
        return this.activeObjectForLeftPanel.valuesForLeftPanel.isUnderline;
      },
      set(newValue) {
        this.activeObjectForLeftPanel.valuesForLeftPanel.isUnderline = newValue;
      },
    },

    getLineSpacing() {
      return (this.activeObjectForLeftPanel) && parseFloat(this.activeObjectForLeftPanel.valuesForLeftPanel.lineSpacing);
    },
    getVerticalAligntop() {
      return this.activeObjectForLeftPanel.verticalAlign.toLowerCase() == 'top' ? true : null;
    },
    getVerticalAlignmiddle() {
      return this.activeObjectForLeftPanel.verticalAlign.toLowerCase() == 'middle' ? true : null;
    },
    getVerticalAlignbottom() {
      return this.activeObjectForLeftPanel.verticalAlign.toLowerCase() == 'bottom' ? true : null;
    },

    getBulletList() {
      return this.activeObjectForLeftPanel.valuesForLeftPanel.isBulletList;
    },
    getNumberList: {
      get() {
        return this.activeObjectForLeftPanel.valuesForLeftPanel.isNumberList;
      },
      set(newValue) {
        console.log(newValue);
      },
    },
    getSupperScript: {
      get() {
        return this.activeObjectForLeftPanel.valuesForLeftPanel.isSuperScript;
      },
    },
    getSubScript: {
      get() {
        return this.activeObjectForLeftPanel.valuesForLeftPanel.isSubScript;
      },
    },
    isImageAlignedLeft() {
      return this.activeObjectForLeftPanel.X === this.productCrop.AllowCropping ? Number(this.productCrop.XCrop) : 0;
    },
    getObjectCanvasAlignment() {
      let position = { left: 'left', top: 'top' };
      if (this.activeObjectForLeftPanel) {
        let objectElement = document.getElementById(this.activeObjectForLeftPanel.Id);
        if (objectElement) {
          objectElement = objectElement.getBoundingClientRect();
        } else {
          position = {
            horizontalAlignment: 'left',
            verticalAlignment: 'top',
          };
          return position;
        }
        const mainHtmlElement       = document.getElementById('main_html').getBoundingClientRect();
        const horizontalCenterCheck = parseInt((this.width - this.activeObjectForLeftPanel.Width) / 2);
        const verticalCenterCheck   = parseInt((this.height - this.activeObjectForLeftPanel.Height) / 2);
        let horizontalAlignment     = '';
        let verticalAlignment       = '';
        if (parseInt(objectElement.left) > parseInt(mainHtmlElement.left) - 2 && parseInt(objectElement.left) < parseInt(mainHtmlElement.left) + 2) {
          horizontalAlignment = 'left';
        }
        if (parseInt(objectElement.right) > parseInt(mainHtmlElement.right) - 2 && parseInt(objectElement.right) < parseInt(mainHtmlElement.right) + 2) {
          horizontalAlignment = 'right';
        }
        if (this.activeObjectForLeftPanel.X > horizontalCenterCheck - 2 && this.activeObjectForLeftPanel.X < horizontalCenterCheck + 2) {
          horizontalAlignment = 'center';
        }
        if (parseInt(objectElement.top) > parseInt(mainHtmlElement.top) - 2 && parseInt(objectElement.top) < parseInt(mainHtmlElement.top) + 2) {
          verticalAlignment = 'top';
        }
        if (this.activeObjectForLeftPanel.Y > verticalCenterCheck - 2 && this.activeObjectForLeftPanel.Y < verticalCenterCheck + 2) {
          verticalAlignment = 'center';
        }
        if (parseInt(objectElement.bottom) > parseInt(mainHtmlElement.bottom) - 2 && parseInt(objectElement.bottom) < parseInt(mainHtmlElement.bottom) + 2) {
          verticalAlignment = 'bottom';
        }
        position = {
          horizontalAlignment,
          verticalAlignment,
        };
      }

      return position;
    },
    isImageAlignedTop() {
      return this.activeObjectForLeftPanel.Y === this.productCrop.AllowCropping ? Number(this.productCrop.YCrop) : 0;
    },

    isAlignedRight() {
      const calcWidth = this.width - this.activeObjectForLeftPanel.Width;
      return this.activeObjectForLeftPanel.X === this.productCrop.AllowCropping ? calcWidth - Number(this.productCrop.XCrop) : calcWidth;
    },

    isAlignedBottom() {
      const calcHeight = this.height - this.activeObjectForLeftPanel.Height;
      return this.activeObjectForLeftPanel.Y === this.productCrop.AllowCropping ? calcHeight - Number(this.productCrop.YCrop) : calcHeight;
    },

    isAlignedMiddle() {
      const calcMid = (this.height - this.activeObjectForLeftPanel.Height) / 2;
      return this.activeObjectForLeftPanel.Y === calcMid;
    },

    isAlignCenter() {
      const calcCenter = (this.width - this.activeObjectForLeftPanel.Width) / 2;
      return this.activeObjectForLeftPanel.X === calcCenter;
    },
    getDisplayHelpText() {
      return localStorage.getItem('displayHelpText') != 'false' && !this.isVideoMoodOn && this.getDisplayHelpTextStore;
    },
    getDisplayHelpTextStore() {
      return this.$store.getters.getDisplayHelpText;
    },
  },
  watch: {
    product(newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal);
    },
  },
  mounted() {
    this.onEnterAnimate = this.activeObject && this.activeObject.animation && this.activeObject.animation.onEnter ? this.activeObject.animation.onEnter : null;
    this.onExitAnimate  = this.activeObject && this.activeObject.animation && this.activeObject.animation.onExit ? this.activeObject.animation.onExit : null;
    window.onresize     = this.setScalePopUP;
    EventBus.$on('modalsCloser', this.onmodalClose);
    EventBus.$on(ApplicationEventTypes.ModalEvents.TOGGLE_CROP_IMAGE_MODAL, this.toggleCrop);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.RESET, this.resetLeftPanelStates);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_FONT_SIZE, this.changeFontSize);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_LINE_HEIGHT, this.changeCharacterSpacing);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_COLOR, this.changeFontColor);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_SHADOW_COLOR, this.updateTextShadowColor);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_OUTLINE_COLOR, this.updateTextOutlineColor);
    EventBus.$on(ApplicationEventTypes.LeftPanelEvents.CHANGE_FONT_FAMILY, this.changeFontFamily);
    EventBus.$on(ApplicationEventTypes.ImageObjectEvents.SELECTED_IMAGE_FOR_LEFT_PANEL, this.addingAlternativeImage);
    EventBus.$on('AddSvgShape', this.onAddingShapeSVG);
    EventBus.$on('addBgRemoverImage', this.addBgRemoverImage);
    this.activeObject && this.activeObject.AlternativeImageUrls && (this.intialImageBorder = this.activeObject.AlternativeImageUrls[0]);
    EventBus.$on('ShowAnimationTray', this.showAnimationTray);
    if (localStorage.getItem('displayHelpText') == null) {
      console.log('displayHelpText');
      localStorage.setItem('displayHelpText', true);
    }
  },
  beforeDestroy() {
    EventBus.$off('modalsCloser', this.onmodalClose);
    EventBus.$off(ApplicationEventTypes.ModalEvents.TOGGLE_CROP_IMAGE_MODAL, this.toggleCrop);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.RESET, this.resetLeftPanelStates);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_FONT_SIZE, this.changeFontSize);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_SHADOW_COLOR, this.updateTextShadowColor);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_OUTLINE_COLOR, this.updateTextOutlineColor);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_LINE_HEIGHT, this.changeCharacterSpacing);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_TEXT_COLOR, this.changeFontColor);
    EventBus.$off(ApplicationEventTypes.LeftPanelEvents.CHANGE_FONT_FAMILY, this.changeFontFamily);
    EventBus.$off(ApplicationEventTypes.ImageObjectEvents.SELECTED_IMAGE_FOR_LEFT_PANEL, this.addingAlternativeImage);
    EventBus.$off('AddSvgShape', this.onAddingShapeSVG);
    EventBus.$off('addBgRemoverImage', this.addBgRemoverImage);
    EventBus.$on('ShowAnimationTray', this.showAnimationTray);
  },
  methods: {
    openColorPicker() {
      if (!this.isColorPickerOpen) {
        this.isColorPickerOpen = true;
      } else {
        this.isColorPickerOpen = false;
      }
    },
    addBgRemoverImage(data) {
      let selectedObject = this.contentList.find(element => element.isSelected == true);
      selectedObject.HighResPath = data.DefaultImageUrl;
      Object.assign(selectedObject, data);
      Object.assign(selectedObject.AlternativeImageUrlsResVersion[0], data);
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
    },
    imageURLHighResPath(objectProps) {
      if (objectProps.HighResPath && objectProps.HighResPath !== 'undefined') {
        if (objectProps.croppedHighResPath !== 'none' && objectProps.croppedHighResPath != 'undefined') {
          return objectProps.croppedHighResPath;
        }
        return objectProps.HighResPath;
      }
      if (objectProps.croppedSrc !== 'none') { return objectProps.croppedSrc; }
      return objectProps.DefaultImageUrl;
    },

    removeImageBackground() {
      EventBus.$emit('showHideLoader', true);
      const imageUrl = this.imageURLHighResPath(this.activeObjectForLeftPanel)
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);

      const bankId    = newUrlSearchParams.has('bankId') ? newUrlSearchParams.get('bankId') : 'fde5ed9d-816f-43fd-89f3-97a542947193';
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=RemoveBackground&imageURL=${imageUrl}&domainURL=https://${domainUrl}.com/&bankId=${bankId}`;

      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', (Response) => {
        const parser            = new DOMParser();
        const xmlParsed         = parser.parseFromString(Response.target.response, 'text/xml');
        let removeBackgroundResult = xmlParsed.getElementsByTagName('RemoveBackgroundResult');
        removeBackgroundResult[0] && (removeBackgroundResult = removeBackgroundResult[0].innerHTML);
        if (removeBackgroundResult.includes('invalid_image_url')) {
          EventBus.$emit('showHideLoader', false);
          EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, { request: 'SaveOrderReject', message: `Could not remove background` });
          return;
        }
        EventBus.$emit("replaceBgRemoverImageUrl", removeBackgroundResult);
        // EventBus.$emit('showHideLoader', false);
      });
      oReq.addEventListener('error', (e) => {
        console.error(e);
        EventBus.$emit('showHideLoader', false);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    updateSelectedGradientAngle(angle) {
      let selectedObject = this.contentList.find(element => element.isSelected == true);
      selectedObject.gradient.angle = angle;
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
      if (selectedObject.ImageType === 'SVGImage' && selectedObject.isGradient) {
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR);
      }
    },
    updateSelectedPointPosition(position) {
      let selectedObject = this.contentList.find(element => element.isSelected == true);
      selectedObject.gradient.colors.find((color) => color.isSelected).position = position;
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
      if (selectedObject.ImageType === 'SVGImage' && selectedObject.isGradient) {
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR);
      }
    },
    updateSelectedPointOfGradient(index) {
      let selectedObject = this.contentList.find(element => element.isSelected == true);
      selectedObject.gradient.colors.forEach((point, i) => {
        point.isSelected = false;
        if (i === index) {
          point.isSelected = true;
        }
      });
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);

      if (selectedObject.ImageType === 'SVGImage' && selectedObject.isGradient) {
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR);
      }
    },
    handleModeChange(isGradient) {
      let selectedObject = this.contentList.find(element => element.isSelected == true);
      selectedObject.isGradient = isGradient;
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
      if (selectedObject.isGradient && selectedObject.ImageType === 'SVGImage') {
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR);
      } else {
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR, selectedObject.SvgProperty.DefaultColor);
      }
    },
    updateTextShadowColor(value) {
      let selectedObject = this.contentList.find(element => element.Id === this.activeObjectForLeftPanel.Id);
      selectedObject.textShadow.shadowColor = value;
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
    },
    updateTextShadowProperty(property, value) {
      let selectedObject = this.contentList.find(element => element.Id === this.activeObjectForLeftPanel.Id);
      const shadow = selectedObject.textShadow;

      const fontSize = parseInt(selectedObject.fontSize) || 16;

      if (property === 'angle' || property === 'distance') {
        shadow.angle = property === 'angle' ? value : shadow.angle;
        shadow.distance = property === 'distance' ? value : shadow.distance;

        const scaledDistance = shadow.distance * (fontSize / 16);

        const radians = (shadow.angle * Math.PI) / 180;
        shadow.shadowOffsetX = scaledDistance * Math.cos(radians);
        shadow.shadowOffsetY = scaledDistance * Math.sin(radians);
      } else {
        shadow[property] = property !== 'shadowColor' ? parseFloat(value) : value;
      }
      selectedObject.textShadow = shadow;
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
    },
    updateTextOutlineProperty(property, value) {
      let selectedObject = this.contentList.find(element => element.Id === this.activeObjectForLeftPanel.Id);
      selectedObject.outLine[property] = property != 'strokeColor' ? parseFloat(value) : value;
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
    },
    updateTextOutlineColor(value) {
      let selectedObject = this.contentList.find(element => element.Id === this.activeObjectForLeftPanel.Id);
      selectedObject.outLine.strokeColor = value;
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
    },
    removeTextEffect() {
      let selectedObject = this.contentList.find(element => element.Id === this.activeObjectForLeftPanel.Id);
      selectedObject.textShadow = {
        textEffect: 'none',
        angle: 0,
        distance: 0,
        shadowBlur: 0,
        shadowColor: "rgb(252,252,252)",
        transparency: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0
      };

      selectedObject.outLine = {
        textEffect: 'none',
        strokeWidth: 0,
        strokeColor: "rgb(252,252,252)"
      };
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
      EventBus.$emit(ApplicationEventTypes.Canvas.CANVAS_RE_RENDER);
    },
    applyShadowOnText() {
      let selectedObject = this.contentList.find(element => element.Id === this.activeObjectForLeftPanel.Id);

      selectedObject.textShadow = {
        textEffect: 'shadow',
        angle: 0,
        distance: 0.75,
        shadowBlur: 0,
        shadowColor: "rgb(132,108,99)",
        transparency: 0,
        shadowOffsetX: 0.75,
        shadowOffsetY: 0
      };

      selectedObject.outLine = {
        textEffect: 'none',
        strokeWidth: 0,
        strokeColor: "rgb(252,252,252)"
      };
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
      EventBus.$emit(ApplicationEventTypes.Canvas.CANVAS_RE_RENDER);
    },
    applyOutlineOnText() {
      let selectedObject = this.contentList.find(element => element.Id === this.activeObjectForLeftPanel.Id);
      selectedObject.textShadow = {
        textEffect: 'none',
        angle: 0,
        distance: 0,
        shadowBlur: 0,
        shadowColor: "rgb(252,252,252)",
        transparency: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0
      };

      selectedObject.outLine = {
        textEffect: 'outline',
        strokeWidth: 0.6,
        strokeColor: "#ff0000"
      };
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
      EventBus.$emit(ApplicationEventTypes.Canvas.CANVAS_RE_RENDER);
    },
    toggleTrim() {
      this.$store.commit('activeProduct/updateISTrimmingEnable', !this.$store.getters['activeProduct/getIsTrimmingEnable']);
    },
    toggleShapeStrokeColorPanel() {
      this.showShapeStrokeColorPanel = !this.showShapeStrokeColorPanel;
    },
    toggleShapeFillColorPanel() {
      this.showShapeFillColorPanel = !this.showShapeFillColorPanel;
    },
    alignObjectPosition(value, productCrop) {
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATE_OBJECT_ALIGNMENT, { value, productCrop });
    },
    showFavouriteSizeInModel() {
      EventBus.$emit(ApplicationEventTypes.ModalEvents.SHOW_SIZE_MODAL, {
        height: this.productSize.height,
        width:  this.productSize.width,
        unit:   this.productSize.selectedUnit,
      });
    },
    toggleProductSizeRatioFlag() {
      EventBus.$emit('toggleProductSizeRatioFlag');
    },
    stopPropagation() {},
    toggleDetailSection() {
      this.$emit('OpenDetailSection');
      // this.isOpenDetailSection ^= true;
    },
    toggleShapeSection() {
      this.toggleShapePanel = !this.toggleShapePanel;
    },
    toggleAnimationSection() {
      this.toggleAnimationPanel = !this.toggleAnimationPanel;
      this.$store.commit('activeProduct/updatePageAnimationPanel', this.toggleAnimationPanel);
    },
    addingAlternativeImage(data) {
      this.activeObjectForLeftPanel.AlternativeImageUrlsResVersion.push(data);
    },
    onAddingShapeSVG({
      content, name, color, width, height,
    }) {
      console.log("ImageObject")
      const { data }           = new ImageObject();
      data.PdfSortOrder        = data.SortOrder = getMaxZIndex(document.getElementById('canvas-wrapper').firstElementChild.children) + 1;
      data.isSelected          = false;
      data.Alpha               = 100;
      data.DefaultColor        = color;
      data.Width               = width;
      data.Height              = height;
      data.X                   = ((this.width / 2) - width / 2);
      data.Y                   = ((this.height / 2) - height / 2);
      data.ImageType           = 'SVGImage';
      data.SvgProperty.content = content;
      data.Name                = name;
      data.Id                  = uuid.v1();
      EventBus.$emit('onObjectAdding', _.cloneDeep(data));
    },
    addShapeObject(objectName) {
      switch (objectName) {
        case 'circle': {
          const { data }             = new BackgroundObject();
          const objectHeight         = this.width <= 125 ? 80 : 200;
          const objectWidth          = this.width <= 125 ? this.width / 1.5 : 200;
          data.shapeType             = 'ellipses';
          data.CurveVerticalRadius   = 100;
          data.CurveHorizontalRadius = 100;
          data.CurveCenterX          = 100;
          data.CurveCenterY          = 100;
          data.PdfSortOrder          = data.SortOrder = getMaxZIndex(document.getElementById('canvas-wrapper').firstElementChild.children) + 1;
          data.isSelected            = false;
          data.Alpha                 = 100;
          data.DefaultColor          = 'rgb(104, 129, 210)';
          data.Width                 = objectWidth;
          data.Height                = objectHeight;
          data.X                     = Math.abs((this.width / 2) - objectWidth / 2);
          data.Y                     = Math.abs((this.height / 2) - objectHeight / 2);
          data.isNewObject           = true;
          // data.svgScaleX             = parseInt(document.getElementById(this.activeObject.Id).style.width)/parseInt(document.getElementById(this.activeObject.Id).firstChild.getAttribute('width'))
          // data.svgScaleY             = parseInt(document.getElementById(this.activeObject.Id).style.height)/parseInt(document.getElementById(this.activeObject.Id).firstChild.getAttribute('height'))
          EventBus.$emit('onObjectAdding', _.cloneDeep(data));

          break;
        }
        case 'rectangle': {
          const { data }     = new BackgroundObject();
          const objectHeight = this.width <= 125 ? 80 : 178;
          const objectWidth  = this.width <= 125 ? this.width / 1.5 : 178;
          data.PdfSortOrder  = data.SortOrder = getMaxZIndex(document.getElementById('canvas-wrapper').firstElementChild.children) + 1;
          data.isSelected    = false;
          data.Alpha         = 100;
          data.DefaultColor  = 'rgb(104, 129, 210)';
          data.Width         = objectWidth;
          data.Height        = objectHeight;
          data.shapeType      = 'rectangle',
          data.X             = Math.abs((this.width / 2) - objectWidth / 2);
          data.Y = Math.abs((this.height / 2) - objectHeight / 2);
          EventBus.$emit('onObjectAdding', _.cloneDeep(data));

          break;
        }
        default:
          break;
      }
    },
    replaceAddressBoxImage(AddressBoxesPath) {
      EventBus.$emit('onReplaceAddressBoxImage', AddressBoxesPath);
    },
    rotateLeft() {
      // this.activeObjectForLeftPanel.RotateDegree -= 5;
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.ROTATE_OBJECT, 1);
      this.emitUndoRedoRequest('Object Rotate');
    },
    rotateRight() {
      // this.activeObjectForLeftPanel.RotateDegree += 5;
      // EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.ROTATE_OBJECT, -1);
      this.emitUndoRedoRequest('Object Rotate');
    },
    replaceImage(ImgSrc) {
      this.intialImageBorder = '';
      EventBus.$emit('onReplaceImage', ImgSrc);
    },
    replaceVideo(video) {
      EventBus.$emit(ApplicationEventTypes.ImageObjectEvents.REPLACE_VIDEO, video);
    },
    resetLeftPanelStates() {
      // this.activeObjectForLeftPanel = null;
    },
    emitUndoRedoRequest(data) {
      EventBus.$emit('addIntoPageWiseUndoRedoArray', data);
    },
    closeModalsDefault(e) {
      try {
        if (this.$refs.transparencyButton && (!(this.$refs.transparencyButton.contains(e.target) || this.$refs.adjustModalBtn.contains(e.target)))) {
          this.popModal.isModalOpen = false;
          this.isScaleOPen          = false;
        }
      } catch (ex) {
        console.log('Error in closing Modal', ex);
      }
    },

    changeFontSize(font) {
      font && this.triggerUpdateTextProperties({
        command:     this.TinyMCECommandTypes.Size,
        value:       `${font}px`,
        commandType: this.TextCommandTypes.TinyMceCommand,
      });
    },
    changeFontFamily(font) {
      font && this.triggerUpdateTextProperties({
        command:     this.TinyMCECommandTypes.FontFamily,
        value:       font,
        commandType: this.TextCommandTypes.TinyMceCommand,
      });
    },
    changeFontColor(rgb) {
      rgb && this.triggerUpdateTextProperties({
        command:     this.TinyMCECommandTypes.Color,
        value:       rgb.toString(),
        commandType: this.TextCommandTypes.TinyMceCommand,
      });
    },
    triggerUpdateTextProperties(payload) {
      payload && EventBus.$emit(ApplicationEventTypes.TextObjectEvents.UPDATED, payload);
    },

    changeCharacterSpacing(lineSpace) {
      lineSpace && this.triggerUpdateTextProperties({
        command:     this.TinyMCECommandTypes.LineSpacing,
        value:       lineSpace,
        commandType: this.TextCommandTypes.TinyMceCommand,
      });
    },
    toggleImageModel() {
      if (this.$store.getters.isImageModel == false) {
        this.$store.commit('setImageModel', true);
      } else {
        this.$store.commit('setImageModel', false);
      }
    },
    toggleVideoModel() {
      if (this.$store.getters.getIsVideoModel === false) {
        this.$store.commit('setIsVideoModel', true);
      } else {
        this.$store.commit('setIsVideoModel', false);
      }
    },
    toggleShapeModel() {
      if (this.$store.getters.isShapeModel == false) {
        this.$store.commit('setShapeModel', true);
      } else {
        this.$store.commit('setShapeModel', false);
      }
    },
    activeButton(object) {
      object.type == 'FDIC' || object.type == 'NCUA' ? EventBus.$emit('changeFdicPhoto', object) : EventBus.$emit('changeHousingPhoto', object.title);
      // this.selectedButton = object.id;
    },
    // fDICImageColorChange(event){
    //   this.selectedButton = id;
    // },
    toggleScalePop() {
      if (this.popModal.isModalOpen === true) {
        this.popModal.isModalOpen = false;
      }
      const modalNode       = this.$refs.adjustModal.getBoundingClientRect();
      const modalDimensions = this.$refs.adjustModalBtn.getBoundingClientRect();
      const modalPosition   = modalDimensions.y;
      const modalHeight     = modalNode.height;
      const viewPortHeight  = window.innerHeight;
      if (viewPortHeight < (modalPosition + modalHeight)) {
        const diff                            = viewPortHeight - modalHeight;
        this.adjustmentInitialPos.topscalepop = diff;
      } else {
        this.adjustmentInitialPos.topscalepop = modalDimensions.y;
      }
      this.adjustmentInitialPos.leftscalepop = modalDimensions.x;
      this.isAdjustmentButtonActive          = !this.isAdjustmentButtonActive;
      this.isScaleOPen                       = !this.isScaleOPen;
    },
    // setScalePopUP() {
    //   const button      = document.getElementById('button-scale').getBoundingClientRect();
    //   this.adjustmentInitialPos.leftscalepop = button.left;
    //   this.adjustmentInitialPos.topscalepop  = button.top;
    // },

    showSelectionDropDown() {
      this.isDropdownShown = !this.isDropdownShown;
    },

    onmodalClose({ checkModal, e }) {
      try {
        if (this.isDropdownShown === true) {
          checkModal = true;
        }
        if (e && !(this.$refs.detailsDropdown.contains(e.target))) {
          this.isDropdownShown = false;
        }
      } catch (ex) {
        console.log(ex.message);
      }
    },

    selected(e) {
      const temp          = this.selectedOption;
      this.selectedOption = e.target.innerText;
      this.valuechange    = temp;
      EventBus.$emit('updateProductSize', e.target.innerText);
      this.$store.commit('setIsUnitInInch', e.target.innerText == 'Inches');
    },

    showTooltip(e) {
      // const toolWidth =  this.$refs.tooltipText;
      const Id = e.currentTarget.id;
      EventBus.$emit('checkToolTip', Id);
    },
    hideTooltip() {
      EventBus.$emit('triggerHide');
    },
    flipHorizontal() {
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.FLIP_OBJECT, 1);
    },
    changeImageEffects(params) {
      const effectValue                                  = (params.name == ImageFilterTypes.TINT) ? { value: params.value, color: params.color } : { value: params.value };
      this.activeObjectForLeftPanel.effects[params.name] = effectValue;
    },
    toggleCrop() {
      if (this.activeObjectForLeftPanel.stencilDefaultPositionTop === null || this.activeObjectForLeftPanel.stencilDefaultPositionLeft === null) {
        const imageObject = document.getElementById(this.activeObjectForLeftPanel.Id).firstElementChild;
        const imgWidth    = imageObject.naturalWidth;
        const imgHeight   = imageObject.naturalHeight;
        const stencilLeft = parseInt((parseInt(imgWidth) - parseInt(this.activeObjectForLeftPanel.Width)) / 2);
        const stencilTop  = parseInt((parseInt(imgHeight) - parseInt(this.activeObjectForLeftPanel.Height)) / 2);
        if (this.activeObjectForLeftPanel.stencilDefaultPositionTop === null) {
          this.activeObjectForLeftPanel.stencilDefaultPositionTop = stencilTop;
        }
        if (this.activeObjectForLeftPanel.stencilDefaultPositionLeft === null) {
          this.activeObjectForLeftPanel.stencilDefaultPositionLeft = stencilLeft;
        }
      }
      const data = {
        isEnable: !this.$store.getters.getCrop.isEnable,
        object:   this.activeObjectForLeftPanel,
      };
      this.$store.commit('updateCrop', data);
    },
    flipVertical() {
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.FLIP_OBJECT, -1);
    },

    openAdjustmentsModal: () => {
      this.isAdjustmentButtonActive = !this.isAdjustmentButtonActive;
    },

    openTransparencyModal(e) {
      if (this.isScaleOPen === true) {
        this.isScaleOPen = false;
      }
      this.popModal.isModalOpen = !this.popModal.isModalOpen;
      const selectedButton      = this.$refs.transparencyButton.getBoundingClientRect();
      const xPosition           = selectedButton.x + 43;
      const yPosition           = selectedButton.y - 3;
      this.isBtnActive          = !this.isBtnActive;
      const position            = {
        x: xPosition,
        y: yPosition,
      };
      this.popModal.position    = position;
    },

    enableVideoMode() {
      console.log('asd');
      this.closeHelpText();
      if (this.videoHelpChecked) {
        localStorage.setItem('displayHelpText', false);
      }
      this.$store.commit('activeProduct/updateIsVideoMoodOn', true);
      EventBus.$emit(ApplicationEventTypes.Video.ToggleVideoMood, true);
    },

    closeHelpText() {
      this.$store.commit('setDisplayHelpText', false);
    },
  },
};

</script>
<style lang="scss">
@import "./src/assets/styles/layout/base";

.custom-width-tool{
  min-width: 110px !important;
}

.figma-plus {
  .icon {
    min-height: auto;
    min-width: auto;
    height: 36px;
    width: 36px;
  }


  svg {
    height: 36px;
    width: 36px;

    &:hover {
      filter: none !important;
      path {
        stroke: $grey80;
        fill: $grey80;
      }

    }
  }
}

.show-outer-box {
  opacity: 1;
  transition: transform 0.3s ease-in-out !important;
}

.invisible{
  opacity: 0 !important;
}

.shape-color-tab{

  display: flex;
  align-items: center;
  justify-content: start;
  font-size: 1.2rem;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
  color: #3f3f3f;
  padding-bottom: 10px;
}
.separator-line{
  height: 1px;
  background-color:  #dee2e6 ;
  margin: 15px -15px 0px -15px;

}

.main-panel-wrapper {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04),
  0px 0px 2px rgba(0, 0, 0, 0.06),
  0px 0px 1px rgba(0, 0, 0, 0.04);
  height: calc(100vh - 68px);
  .colorActive.bm-small-btns {
    svg{
      filter: invert(56%) sepia(30%) saturate(1577%) hue-rotate(176deg) brightness(105%) contrast(96%);
    } &:hover{
        svg{
          filter: invert(56%) sepia(30%) saturate(1577%) hue-rotate(176deg) brightness(105%) contrast(96%) !important;
        }        }
  }


  .main-widget-wrapper {
    overflow-y: auto;
    overflow-x: hidden;

    .shape-selector {
      &.showdropdown {
        display: block !important;
      }
    }

    .rotate-icon {
      transform: rotate(-180deg);
    }

    .widget-inner {
      border-bottom: 1px solid $grey20;
    }

    .expand-icon {
      cursor: pointer;
    }


    .shape-selector {
      .bm-bordered-btn {
        min-width: 0px;
        width: 78px;
        max-width: 100%;
        padding: 13px;

        &:hover {
          svg {
            path {
              stroke: $grey90;
            }
          }
        }
      }

      .shape-selector {
        &.showdropdown {
          display: block !important;
        }
      }

      .dropdown-panel {
        box-shadow: inset 0px 0px 8px rgba(0, 0, 0, 0.08);
        cursor: pointer;

        .selected-font {
          @include FontVariation(1.4rem, normal, 'Open Sans', $grey80);
          line-height: 24px;
        }
      }

      .dropdown-selection {
        @extend .dropdown-panel;
        left: 0;
        top: 35px;
        border-radius: 0px 0px 4px 4px;
        z-index: 1;

        .selection {
          cursor: pointer;
          @extend .selected-font;

          &:hover {
            background-color: #F7FCFF;
            color: $blue50;
          }
        }
      }

      .font-family-selection {

        .color-code {
          &.bm-small-btns {
            line-height: 24px;
            width: 84px;
            font-family: "Open Sans", sans-serif;
          }
        }
      }

      .color-select-buttons-wrapper {
        .bm-bordered-btn {
          background: $grey10;
          border: 1px solid $grey20;
          color: $grey70;
          flex: 1 1 50%;
          margin-right: 16px;

          &:last-child {
            margin-right: 0px;
          }

          &:active {
            color: $blue50;
            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04) !important;
            background: transparent;
          }
        }
      }

      .size-select-button {
        box-shadow: inset 0px 0px 8px rgba(0, 0, 0, 0.08);

        .change-btn{
          &:active{
            svg{
              filter:invert(56%) sepia(30%) saturate(1577%) hue-rotate(176deg) brightness(105%) contrast(96%);
            }
          }
        }
      }

      .zoom-btn {
        &:hover {
          svg {
            path {
              stroke: $grey90;
            }
          }
        }

        &:active {
          svg {
            path {
              stroke: #3bb0fa !important;
            }
          }
        }
      }

      .zoom-amount {
        @include FontVariation(1.4rem, 400, Open Sans, $grey80);
      }

      .size-controller-wrapper {
        flex: 1 1 50%;

        /*&:last-child {*/
        /*  margin-right: 0px;*/
        /*}*/
      }

      .text-field {
        box-shadow: inset 0px 0px 8px rgba(0, 0, 0, 0.08);
        @include FontVariation(1.4rem, 400, "Open Sans", $grey80);
      }


      .utility-buttons-wrapper {
        .switch {
          height: 8px;
          width: 12px;

          input {
            opacity: 0;
          }
        }

        .slider {
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          -webkit-transition: .4s;
          transition: .4s;

          &:before {
            position: absolute;
            content: "";
            height: 4px;
            width: 4px;
            left: 1px;
            top: 1px;
            background-color: white;
            border: 1px solid $grey80;
            -webkit-transition: .4s;
            transition: .4s;
          }
        }

        input {
          &:checked {
            + .slider {
              border: 1px solid $blue50 !important;

              &:before {
                -webkit-transform: translateX(3px);
                -ms-transform: translateX(3px);
                transform: translateX(3px);
                border: 1px solid $blue50 !important;
              }
            }

            ~ .toggle-label {
              color: green;
            }
          }

          &:focus {
            + .slider {
              box-shadow: 0 0 1px #2196F3;
            }
          }
        }

        .slider {
          &.round {
            &:before {
              border-radius: 50%;
            }
            border-radius: 34px;
          }
        }
      }

      .dropdown-panel {
        cursor: pointer;
      }

      .tooltip-button {
        &:hover {
          > .tooltip {
            opacity: 1;
          }
        }
      }
      .unit-select{
        width: 90px !important;
        flex-grow: 0;
        flex-shrink: 0;
      }


      .shadowed-btn {
        &:hover {
          background: #ffffff;
          box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.04),
          0px 2px 6px rgba(0, 0, 0, 0.04),
          0px 0px 1px rgba(0, 0, 0, 0.04);
          border: 1px solid transparent !important;
        }
      }
    }

    /*.details-text-field {*/
    /*  padding-right: 12.8px;*/
    /*  padding-left: 12.8px;*/
    /*}*/

    .text-box-images {
      @include FontVariation(1.2rem, 600, 'Open Sans', $grey70);
      line-height: 20px;
    }

    .button-box-thumbnail {
      @extend .bm-small-btns;
      img {
      }
    }

    .main-box {
      .icon-btn {
        width: 36px;
        height: 36px;
      }
    }

    /*.compound-buttons {*/
    /*  input[type="checkbox"] {*/
    /*    height: 0 !important;*/
    /*    width: 0 !important;*/
    /*    opacity: 0 !important;*/
    /*    &:checked ~ {*/
    /*      label {*/
    /*        .lf-btn {*/
    /*          color: #3bb0fa;*/
    /*          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)*/
    /*        }*/
    /*      }*/
    /*    }*/
    /*  }*/

    /*}*/
  }

  .rotate-flip-margin {
    margin-right: 64px;
  }

  .address-boxes {
    h2 {
      font-weight: 800 !important;
    }
  }

  .position {
    position: absolute;
    z-index: 5;
    left: 40px;
    top: 160px
  }

  .position2 {
    position: absolute;
    z-index: 5;
    left: 300px;
    top: 160px;
  }

  .checkbox-button-wrapper {
    .checkmark {
      &:disabled ~ {
        .bm-small-btns {
          svg{
            filter: invert(80%) sepia(1%) saturate(30%) hue-rotate(315deg) brightness(95%) contrast(91%);

          }

        }
      }
      &:checked ~ {
        .bm-small-btns {
          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);

          svg {
            filter: invert(56%) sepia(30%) saturate(1577%) hue-rotate(176deg
            ) brightness(105%) contrast(96%);
          }
        }
      }
      opacity: 0;
      height: 0px;
      width: 0px;
    }
  }
  .unchecked-boxes{
    .checkmark{
      display: none;
    }
  }

  .thumbnail-box {
    &:hover {
      box-shadow: rgba(0, 0, 0, 0.35) 0px -2px 8px;
    }
  }
  .shapes{
    .tooltip-wrapper{
      top: 57px;
    }
  }
  .transparency{
    width: 386px;
    z-index: 999;
    box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
  }
  .shape-btn{

  }
  .add-new-btn{
    &:hover{
      svg{
        filter: invert(0%) sepia(2%) saturate(3238%) hue-rotate(
            321deg) brightness(92%) contrast(199%);
      }
    }
  }

}


//Image Effect style box start
.outer-box{
  width:368px;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  position:fixed;
  z-index: 9999;
  background: #ffff;
  transform-origin: top;
  left: 205px;
  top: 500px;
  transition:  0.3s ease-in-out;
}

@media screen and (min-width: 1540px ) {
  .outer-box{
    left: 230px;
  }
}
@media screen and (min-width: 1601px ) {
  .outer-box{
    left: 260px;
  }
}

@media screen and (min-width: 1650px ) {
  .outer-box{
    left: 290px;
  }
}

@media screen and (min-width: 1706px ) {
  .outer-box{
    left: 300px;
  }
}
@media screen and (min-width: 1906px ) {
  .outer-box{
    left: 320px;
  }
}

.dimensions-select {

  .text-field{
    width: 80px !important;
  }


}
.max-z-index{
  z-index: 4000 !important;
}

.icon-tilt{
  .custom-icon:nth-of-type(2){
    transform: rotate(-180deg);
  }

}
//Image Effect style box end
.animation-panel {
  .active {
    position: relative;

    &::after {
      content: "";
      width: 50px;
      height: 25px;
      // background-color: #F2F2F2;
      position: absolute;
      bottom: -25px;
      transform: translate(-50%, 0%);
      left: 50%;
      background-image: url("~@/assets/images/Polygon.png");
      background-repeat: no-repeat;
      background-position: top center;
    }
  }
}

.animation-row {
  display: flex;
  justify-content: flex-start;
  text-align: center;
  padding-left: 15px;
  padding-right: 20px;
  // position: absolute;
  // width: 100%;

  img {
    border-radius: 6px;
    cursor: pointer;
  }

  h5 {
    font-size: 11px;
    margin-top: 4px;
  }
  div {
    margin-right: 18px;
  }
}

//Range Input
.range__input {
  appearance: none;
  width: calc(100% - (73px));
  height: 4px;
  border-radius: 5px;
  background: #d6d6d6;
  outline: none;
  padding: 0;
  margin: 0;
}

.range__input::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background: #ffffff;
  border: 2px solid #3bb0fa;
  cursor: pointer;
  transition: background 0.15s ease-in-out;
}

.range__input::-webkit-slider-thumb:hover {
  transform: scale(1.1);
  background: #1abc9c;
}

.range__input:active::-webkit-slider-thumb {
  transform: scale(1.1);
  background: #1abc9c;
}

.animation-row {
  img {
    width: 77px;
    height: 77px;
    border: 0.2px solid #AEAEAE;
    border-radius: 6px;
  }

  .selected {
    img {
      border: 1px solid #3bb0fa;
    }
  }
}

.font-size-weight {
  font-family: 'Open Sans';
  font-style: normal;
  line-height: 20px;
}

.remove-container {
  position: relative;
  width: 100%;
  bottom: 0;
  background: white;
  margin-top: 15px;
}

.remove_animation{
  color: #ffffff;
  background: #3bb0fa;
  border-radius: 4px;
  padding: 8px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  border: 0;
  outline: 0;
  width:100%;
  &:hover {
    background-color: #0095F2;
  }
}

</style>
<style lang="scss" scoped>
.stroke-width-text{
  flex: 0 0 85px;
  font-size: 11px;
  text-transform: capitalize;
}
.slider-container{
  flex: 1 1 auto;
  height: 20px;

}
.slider{
  &:focus{
    border: none;
  }
  -webkit-appearance: none;
  height:4px;
  background: linear-gradient(90deg,rgb(214,214,214)60%,rgb(214,214,214)60%);
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition-opacity:0.2s;
}

.slider::-webkit-slider-thumb{
  -webkit-appearance: none;
  appearance: none;
  width:16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  border:rgb(59, 176, 250) 2px solid ;
}

.slider::-moz-range-thumb{
  appearance: none;
  width:16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  border:rgb(59, 176, 250) 2px solid ;
}
.slider::-webkit-slider-thumb:hover{
  cursor: pointer;
}
.sub-menu-arrow{
  position: absolute;
  left: 300px;
}
.box{
  background: #FFFFFF;
  /* Grey/20 */

  border: 1px solid #EDEDED;
  box-sizing: border-box;
  box-shadow: inset 0px 0px 8px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  width: 60px;
  height: 36px;
}
.box-value{
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 171% */

  text-align: center;

  /* Grey/80 */

  color: #3F3F3F;
}

.box-name{
  height: 20px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 20px;
  /* identical to box height, or 200% */

  text-transform: uppercase;

  /* Grey/70 */

  color: #5F5F5F;

}

.help-text{
  background: red;
  position: fixed;
  z-index: 999;
  left: 360px;
  top: 45px;
  width: 400px;
  background: white;
  border-radius: 3px;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);


  .help-text-container{
    position: relative;
    z-index: 3;
    &::before{
      position: absolute;
      content: " ";
      top: 15px;
      left: -10px;
      height: 20px;
      width: 20px;
      background: white;
      transform: rotate(45deg);
      z-index: -1;
      box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
    }
    .help-text-header{
      background-color: #ffffff;
      border-bottom: 1px solid #EDEDED;
      padding: 15px 20px;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      overflow: hidden;

      h4{
        margin: 0;
      }
    }
    .help-text-body{
      padding: 15px 20px;
      background: white;
      border-bottom-right-radius: 3px;
      border-bottom-left-radius: 3px;
    }
  }

  p{
    font-size: 14px;
  }

  .closer{
    position: absolute;
    width: 200vw;
    height: 200vh;
    left: 0;
    z-index: 2;
    top: 0;
    transform: translate(-50%, -50%);
  }

}

.effects-btn {
  border: 1px solid #ededed;
  border-radius: 8px;
  overflow: hidden;
  width: 80px;
  height: 80px;
  cursor: pointer;
}

.active-effect {
  border: 1px solid #00a6f5;
}

.effects-style-container {
  margin-top: 17px;
  border-radius: 8px;

  .effects-subpanel {

    .effect-container {
      display: flex;
      align-items: center;
      justify-content: space-between;

      input {
        width: 220px;
      }

      .box-effects {
        border-radius: 8px;
        font-size: large;
        width: 50px;
        height: 35px;
        background: white;
      }
    }
  }

  .color-effect {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}

.gradient-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  .color_picker_wrapper {
    width: 100%;

    .color_picker_box {
      width: 100%;
      box-shadow: none !important;
      border-radius: 0 !important;
      background: #ffffff !important;
      padding: 0 !important;

      .gcolor_deg {
        display: none;
      }
    }
  }
  .gcolor_deg{
    display: none;
  }
}
</style>
